import { useState, useEffect, useCallback } from "react";
// import CondIcon from "../assets/conductor-icon.png";
import CondIcon from "../assets/conductor-icon-2.png";
import DataTable from "react-data-table-component";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";
import { useLocation } from "react-router-dom";
import Crew from "../assets/crew.png";
import DutyPostingService from "../services/dutyposting,service";
import axios from "axios";
import DutyDetails from "./DutyDetails";
import CanceledDuty from "./CanceledDuty";
import AllocatedDuty from "./AllocatedDuty";
import { useStateContext } from "../contexts/ContextProvider";
import { RiCheckDoubleFill } from "react-icons/ri";
import ExtraDuty from "./ExtraDuty";

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(null, args);
    }, delay);
  };
};

const DutyList = () => {
  const location = useLocation();
  const currentDate = new Date();

  // const [selectedFile, setSelectedFile] = useState(null);

  const { user, TEST_BK_URL } = useStateContext();

  const [height, setHeight] = useState(window.innerHeight);

  const [depo, setDepo] = useState("");
  const [checked, setChecked] = useState("1");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [search, setSearch] = useState("");
  const [search2, setSearch2] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [crewData, setCrewData] = useState([]);
  const [drvList, setDrvList] = useState([]);
  const [condList, setCondList] = useState([]);
  const [filter2, setFilter2] = useState(false);
  const [filteredDataDrv, setFilteredDataDrv] = useState([]);
  const [filteredDataCond, setFilteredDataCond] = useState([]);
  const [editDutyNo, setEditDutyNo] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show6, setShow6] = useState(false);
  const [show7, setShow7] = useState(false);

  const [empType, setEmpType] = useState("");

  const [edit, setEdit] = useState(false);
  const [dutyLists, setDutyLists] = useState([]);
  const [busList, setBusList] = useState([]);
  const [showBusList, setShowBusList] = useState(false);
  const [dutyData, setDutyData] = useState({});
  const [selectedDrv, setSelectedDrv] = useState("");
  const [selectedCon, setSelectedCon] = useState("");
  const [selectedReason, setSelectedReason] = useState("9");
  const [selectBus, setSelectBus] = useState(false);
  const [allocatedDuty, setAllocatedDuty] = useState([]);
  const [canceledDuty, setCanceledDuty] = useState([]);
  const [extraDuty, setExtraDuty] = useState([]);

  const [extraDutyCount, setExtraDutyCount] = useState(0);

  const [pndDrv, setPndDrv] = useState([]);
  const [pndCond, setPndCond] = useState([]);
  const [pndBusNo, setPndBusNo] = useState([]);

  const [isDrvChange, setIsDrvChange] = useState(false);
  const [isCondChange, setIsCondChange] = useState(false);

  const [reasonChange, setReasonChnage] = useState(false);

  const [changedDuty, setChangedDuty] = useState("");

  const spareCode = [
    "SPARE",
    "spare",
    "Other",
    "Workshop",
    "STAFFCAR",
    "OFFICE",
  ];

  useEffect(() => {
    const handleResize = () => setHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTabClick = (index) => {
    setFilter(false);
    setSearch("");
    setCurrentIndex(index);
  };

  const handleSelectChange = (e) => {
    setSelectedReason(e.target.value);
  };

  const getDrvList = (statuscode) => {
    const payload = {
      statuscode: statuscode,
    };

    DutyPostingService.getEmployees(payload)
      .then((resp) => {
        const uniqueArray = resp.data.filter(
          (obj, index, self) =>
            index ===
            self.findIndex(
              (o) =>
                o.empcode === obj.empcode && o.designation === obj.designation
            )
        );

        setCrewData(uniqueArray);

        const drvData = uniqueArray.filter(
          (item) => item.designation === "Driver"
        );
        const condData = uniqueArray.filter(
          (item) => item.designation === "Conductor"
        );

        setDrvList(drvData);
        setCondList(condData);
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    // getDrvList("1");
    let intervalId;
    intervalId = setInterval(getDrvList("1"), 5000);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, []);

  const onDragStartCon = (event, conId, isPresent, type) => {
    setEdit(true);
    event.dataTransfer.setData("draggedItemIndex", conId);
    event.dataTransfer.setData("draggedItemIndexPresent", isPresent);
    event.dataTransfer.setData("draggedItemIndexType", type);
  };

  const onDropCon = (event, dropIndex) => {
    const draggedItemIndex = event.dataTransfer.getData("draggedItemIndex");
    const draggedItemIndexPresent = event.dataTransfer.getData(
      "draggedItemIndexPresent"
    );
    const draggedItemIndexType = event.dataTransfer.getData(
      "draggedItemIndexType"
    );
    if (draggedItemIndexType === "cond") {
      if (draggedItemIndexPresent === "1" || draggedItemIndexPresent === "3") {
        setShow3(true);
        setSelectedCon(draggedItemIndex);
        setDutyData(dropIndex);
      } else {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>वाहक उपस्थित नाही.</div>
              <div>Conductor is not Available!</div>
            </div>
          </>
        );
        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      // alert("Driver Selected");
      const message = (
        <>
          <div className="d-flex flex-column">
            <div>कृपया वाहक निवडा.</div>
            <div>Please select Conductor!</div>
          </div>
        </>
      );

      toast.warn(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const onDragStartDrv = (event, drvId, isPresent, type) => {
    setEdit(true);
    event.dataTransfer.setData("draggedItemIndex2", drvId);
    event.dataTransfer.setData("draggedItemIndexPresent2", isPresent);
    event.dataTransfer.setData("draggedItemIndexType2", type);
  };

  const onDropDrv = (event, dropIndex) => {
    const draggedItemIndex = event.dataTransfer.getData("draggedItemIndex2");
    const draggedItemIndexPresent = event.dataTransfer.getData(
      "draggedItemIndexPresent2"
    );
    const draggedItemIndexType = event.dataTransfer.getData(
      "draggedItemIndexType2"
    );

    if (draggedItemIndexType === "drv") {
      if (draggedItemIndexPresent === "1" || draggedItemIndexPresent === "3") {
        setShow4(true);
        setSelectedDrv(draggedItemIndex);
        setDutyData(dropIndex);
      } else {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>चालक उपस्थित नाही.</div>
              <div>Driver is not Available!</div>
            </div>
          </>
        );
        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      const message = (
        <>
          <div className="d-flex flex-column">
            <div>कृपया चालक निवडा.</div>
            <div>Please select Driver!</div>
          </div>
        </>
      );

      toast.warn(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  const fetchData = async () => {
    const payload = {
      postingdate: moment(new Date(currentDate)).format("YYYY-MM-DD"),
      // postingdate: "2025-10-07",
      routecode: "0",
      pbook: user.posting,
    };

    try {
      const response = await axios.post(
        `${TEST_BK_URL}/api/Route/GetTodayschedule`,
        payload
      );

      const result = await response.data;
      const arr2 = result.map((item) => ({
        ...item,
        // delayReason: item.dutyAllot !== "1" ? "9" : item.delayReason,
        delayReason:
          item.delayReason === "No Delay" || item.delayReason !== ""
            ? "9"
            : item.delayReason,
      }));

      const scheduledData = arr2.filter((item) => item.sortflag === "0");
      const pndDrvData = arr2.filter((item) => item.sortflag === "2");
      // const pndCondData = arr2.filter((item) => item.sortflag === "1");

      const pndCondData = arr2.filter((item) => item.sortflag === "1");

      setDutyLists(scheduledData);
      setPndDrv(pndDrvData);
      setPndCond(pndCondData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchAllocatedDuty = () => {
    DutyPostingService.getAllocatedDuty().then((resp) =>
      setAllocatedDuty(resp.data)
    );
  };

  const fetchCanceledDuty = () => {
    DutyPostingService.getCanceledDuty().then((resp) =>
      setCanceledDuty(resp.data)
    );
  };

  const fetchExtraDutys = () => {
    DutyPostingService.fetchExtraDutys().then((resp) => {
      setExtraDuty(resp.data);
      setExtraDutyCount(resp.data.length);
    });
  };

  const fetchBusAllotDuty = () => {
    DutyPostingService.getBusAllotDuty().then((resp) => {
      const data = resp.data.map((item) => ({
        ...item,
        // delayReason: item.dutyAllot !== "1" ? "9" : item.delayReason,
        delayReason:
          item.delayReason === "No Delay" || item.delayReason !== ""
            ? "9"
            : item.delayReason,
      }));
      setPndBusNo(data);
    });
  };

  useEffect(() => {
    const depoName = location.pathname.includes("/wagle/dutyList")
      ? "wagle"
      : location.pathname.includes("/anandnagar/dutyList")
      ? "anandnagar"
      : location.pathname.includes("/kopari/dutyList")
      ? "kopari"
      : "";
    setDepo(depoName);
  }, [location.pathname]);

  useEffect(() => {
    fetchData();
    fetchAllocatedDuty();
    fetchCanceledDuty();
    fetchBusAllotDuty();
    fetchExtraDutys();
  }, []);

  useEffect(() => {
    let intervalId;
    if (!edit) {
      intervalId = setInterval(fetchData, 10000);
    } else {
      setTimeout(() => {
        setEdit(false);
      }, 60000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [edit]);

  const checkCrewNo = (empCode, crewid, workno, dutyListsData) => {
    const payload = {
      empCode: empCode,
      crewid: crewid,
    };

    const payloadNew = {
      empoCode: empCode,
      empType: crewid,
    };

    DutyPostingService.checkCrewMannualyNew(payloadNew)
      .then((resp) => {
        if (resp.data.locId === "10") {
          DutyPostingService.checkCrewMannualy(payload)
            .then((resp) => {
              // console.log(resp.data);
              const errorCodes = ["2", "0", "4"];
              const empType = `${crewid === "2" ? "Driver" : "Conductor"}`;
              const message =
                resp.data.status === "2" ? (
                  `${empType} is already allocated to another Duty!`
                ) : resp.data.status === "0" ? (
                  <>
                    <div className="d-flex flex-column">
                      <div>
                        {empType === "Driver" ? "चालक" : "वाहक"} उपस्थित नाही.
                      </div>
                      <div>{empType} is not available</div>
                    </div>
                  </>
                ) : resp.data.status === "4" ? (
                  <>
                    <div className="d-flex flex-column">
                      <div>
                        कृपया {empType === "Driver" ? "चालक" : "वाहक"} क्रमांक
                        तपासा.
                      </div>
                      <div>Please check the {empType} Number.</div>
                    </div>
                  </>
                ) : (
                  ""
                );
              if (errorCodes.includes(resp.data.status)) {
                toast.warn(message, {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setIsCondChange(false);
                setIsDrvChange(false);

                fetchData();
              } else if (resp.data.status === "1") {
                if (crewid === "1") {
                  const draggedCondData = JSON.parse(
                    localStorage.getItem("draggedCondData")
                  );

                  const message = (
                    <>
                      <div className="d-flex flex-column">
                        <div>
                          वाहक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.
                        </div>
                        <div>
                          Conductor code is already added to another duty.
                        </div>
                      </div>
                    </>
                  );

                  if (
                    draggedCondData &&
                    draggedCondData.filter(
                      (item) =>
                        item.condNo === empCode &&
                        item.workno !== dutyData.workno
                    ).length > 0
                  ) {
                    toast.warn(message, {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                  } else if (
                    draggedCondData.filter(
                      (item) =>
                        item.condNo === selectedCon &&
                        item.workno === dutyData.workno
                    ).length > 0
                  ) {
                    const newArr = dutyListsData.map((item2, idx) => {
                      if (workno === item2.workno) {
                        return {
                          ...item2,
                          conductorNo: empCode,
                          conductorPresenty: "1",
                        };
                      }
                      return item2;
                    });
                    setIsCondChange(true);
                    setDutyLists(newArr);
                    setChangedDuty(workno);
                  } else {
                    const newArr = dutyListsData.map((item2, idx) => {
                      if (workno === item2.workno) {
                        return {
                          ...item2,
                          conductorNo: empCode,
                          conductorPresenty: "1",
                        };
                      }
                      return item2;
                    });
                    setIsCondChange(true);
                    setDutyLists(newArr);
                    setChangedDuty(workno);
                    setDraggedCondDatas((prevValues) => {
                      const exists = prevValues.some(
                        (item) => item.workno === workno
                      );
                      if (exists) {
                        return prevValues.map((item) =>
                          item.workno === workno
                            ? { ...item, condNo: empCode }
                            : item
                        );
                      } else {
                        return [
                          ...prevValues,
                          {
                            workno: workno,
                            condNo: empCode,
                          },
                        ];
                      }
                    });
                  }
                } else if (crewid === "2") {
                  const draggedDrvData = JSON.parse(
                    localStorage.getItem("draggedDrvData")
                  );
                  if (
                    draggedDrvData &&
                    draggedDrvData.filter(
                      (item) =>
                        item.driverNo === empCode && item.workno !== workno
                    ).length > 0
                  ) {
                    const message = (
                      <>
                        <div className="d-flex flex-column">
                          <div>
                            चालक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.
                          </div>
                          <div>
                            Driver code is already added to another duty.
                          </div>
                        </div>
                      </>
                    );

                    toast.warn(message, {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                  } else {
                    const newArr = dutyListsData.map((item2, idx) => {
                      if (workno === item2.workno) {
                        return {
                          ...item2,
                          driverNo: empCode,
                          driverPresenty: "1",
                        };
                      }
                      return item2;
                    });
                    setDutyLists(newArr);
                    setShow4(false);
                    setIsDrvChange(true);
                    setChangedDuty(workno);
                    setDraggedDrvDatas((prevValues) => {
                      const exists = prevValues.some(
                        (item) => item.workno === workno
                      );
                      if (exists) {
                        return prevValues.map((item) =>
                          item.workno === workno
                            ? { ...item, driverNo: empCode }
                            : item
                        );
                      } else {
                        return [
                          ...prevValues,
                          {
                            workno: workno,
                            driverNo: empCode,
                          },
                        ];
                      }
                    });
                  }
                }
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else if (resp.data.locId !== "0") {
          if (crewid === "1") {
            const draggedCondData = JSON.parse(
              localStorage.getItem("draggedCondData")
            );

            if (
              draggedCondData &&
              draggedCondData.filter(
                (item) =>
                  item.condNo === empCode && item.workno !== dutyData.workno
              ).length > 0
            ) {
              const message = (
                <>
                  <div className="d-flex flex-column">
                    <div>वाहक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.</div>
                    <div>Conductor code is already added to another duty.</div>
                  </div>
                </>
              );

              toast.warn(message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else if (
              draggedCondData.filter(
                (item) =>
                  item.condNo === selectedCon && item.workno === dutyData.workno
              ).length > 0
            ) {
              const newArr = dutyListsData.map((item2, idx) => {
                if (workno === item2.workno) {
                  return {
                    ...item2,
                    conductorNo: empCode,
                    conductorPresenty: "1",
                  };
                }
                return item2;
              });
              setIsCondChange(true);
              setDutyLists(newArr);
              setChangedDuty(workno);
            } else {
              const newArr = dutyListsData.map((item2, idx) => {
                if (workno === item2.workno) {
                  return {
                    ...item2,
                    conductorNo: empCode,
                    conductorPresenty: "1",
                  };
                }
                return item2;
              });
              setIsCondChange(true);
              setDutyLists(newArr);
              setChangedDuty(workno);
              setDraggedCondDatas((prevValues) => {
                const exists = prevValues.some(
                  (item) => item.workno === workno
                );
                if (exists) {
                  return prevValues.map((item) =>
                    item.workno === workno ? { ...item, condNo: empCode } : item
                  );
                } else {
                  return [
                    ...prevValues,
                    {
                      workno: workno,
                      condNo: empCode,
                    },
                  ];
                }
              });
            }
          } else if (crewid === "2") {
            const draggedDrvData = JSON.parse(
              localStorage.getItem("draggedDrvData")
            );
            if (
              draggedDrvData &&
              draggedDrvData.filter(
                (item) => item.driverNo === empCode && item.workno !== workno
              ).length > 0
            ) {
              const message = (
                <>
                  <div className="d-flex flex-column">
                    <div>चालक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.</div>
                    <div>Driver code is already added to another duty.</div>
                  </div>
                </>
              );
              toast.warn(message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else {
              const newArr = dutyListsData.map((item2, idx) => {
                if (workno === item2.workno) {
                  return {
                    ...item2,
                    driverNo: empCode,
                    driverPresenty: "1",
                  };
                }
                return item2;
              });
              setDutyLists(newArr);
              setShow4(false);
              setIsDrvChange(true);
              setChangedDuty(workno);
              setDraggedDrvDatas((prevValues) => {
                const exists = prevValues.some(
                  (item) => item.workno === workno
                );
                if (exists) {
                  return prevValues.map((item) =>
                    item.workno === workno
                      ? { ...item, driverNo: empCode }
                      : item
                  );
                } else {
                  return [
                    ...prevValues,
                    {
                      workno: workno,
                      driverNo: empCode,
                    },
                  ];
                }
              });
            }
          }
        } else {
          const message = (
            <>
              <div className="d-flex flex-column">
                <div>
                  कृपया {empType === "Driver" ? "चालक" : "वाहक"} क्रमांक तपासा.
                </div>
                <div>Please check the {empType} Number.</div>
              </div>
            </>
          );
          toast.warn(message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsCondChange(false);
          setIsDrvChange(false);

          fetchData();
        }
      })
      .catch((e) => console.log(e));
  };

  const debouncedCallCheckCrewNo = useCallback(debounce(checkCrewNo, 1500), []);

  const handleInputChange = (e, rowIndex, key, workno) => {
    // console.log(rowIndex, key, workno);
    const value = e.target.value;
    setEdit(true);

    if (currentIndex === 0) {
      setDutyLists((prevData) =>
        prevData.map((row) =>
          row.workno === workno ? { ...row, [key]: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === workno ? { ...row, [key]: value } : row
          )
        );
      }
    } else if (currentIndex === 1) {
      setPndCond((prevData) =>
        prevData.map((row) =>
          row.workno === workno ? { ...row, [key]: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === workno ? { ...row, [key]: value } : row
          )
        );
      }
    } else if (currentIndex === 2) {
      setPndDrv((prevData) =>
        prevData.map((row) =>
          row.workno === workno ? { ...row, [key]: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === workno ? { ...row, [key]: value } : row
          )
        );
      }
    } else if (currentIndex === 3) {
      setPndBusNo((prevData) =>
        prevData.map((row) =>
          row.workno === workno ? { ...row, [key]: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === workno ? { ...row, busNO: value } : row
          )
        );
      }
    }

    if (key === "driverNo") {
      debouncedCallCheckCrewNo(value, "2", workno, dutyLists);
    } else if (key === "conductorNo") {
      debouncedCallCheckCrewNo(value, "1", workno, dutyLists);
    } else if (key === "delayReason") {
      setReasonChnage(true);
    }
  };

  const fetchVehicleList = (value) => {
    const payload = {
      busNo: value,
    };

    DutyPostingService.getBusInfo(payload).then((resp) => {
      if (resp.data) {
        setBusList(resp.data);
      }
    });
  };

  const debouncedCallApi = useCallback(debounce(fetchVehicleList, 500), []);

  // console.log("currentIndex", currentIndex);

  const handleSelectBusNo = (e, rowIndex, dutyNo) => {
    const value = e.target.value;
    // console.log(value);
    setEdit(true);
    setEditDutyNo(dutyNo);
    if (value.length > 0) {
      setShowBusList(true);
    } else {
      setShowBusList(false);
      setSelectBus(false);
    }

    // Update the underlying list for the current tab.
    // Scheduled duties (tab index 0)
    if (currentIndex === 0) {
      setDutyLists((prevData) =>
        prevData.map((row, idx) =>
          row.workno === dutyNo ? { ...row, busNO: value } : row
        )
      );

      // if search filter is active, also update the filteredData so the visible row reflects changes
      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === dutyNo ? { ...row, busNO: value } : row
          )
        );
      }
    } else if (currentIndex === 1) {
      setPndCond((prevData) =>
        prevData.map((row, idx) =>
          row.workno === dutyNo ? { ...row, busNO: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === dutyNo ? { ...row, busNO: value } : row
          )
        );
      }
    } else if (currentIndex === 2) {
      setPndDrv((prevData) =>
        prevData.map((row, idx) =>
          row.workno === dutyNo ? { ...row, busNO: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === dutyNo ? { ...row, busNO: value } : row
          )
        );
      }
    } else if (currentIndex === 3) {
      setPndBusNo((prevData) =>
        prevData.map((row, idx) =>
          row.workno === dutyNo ? { ...row, busNO: value } : row
        )
      );

      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row) =>
            row.workno === dutyNo ? { ...row, busNO: value } : row
          )
        );
      }
    }

    debouncedCallApi(value);
  };

  const handleSelect = (e, index, value) => {
    e.preventDefault();

    if (currentIndex === 0) {
      setDutyLists((prevData) =>
        prevData.map((row, idx) =>
          idx === index ? { ...row, busNO: value } : row
        )
      );

      // if search filter is active, also update the filteredData so the visible row reflects changes
      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row, idx) =>
            idx === index ? { ...row, busNO: value } : row
          )
        );
      }
    } else if (currentIndex === 1) {
      setPndCond((prevData) =>
        prevData.map((row, idx) =>
          idx === index ? { ...row, busNO: value } : row
        )
      );

      // if search filter is active, also update the filteredData so the visible row reflects changes
      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row, idx) =>
            idx === index ? { ...row, busNO: value } : row
          )
        );
      }
    } else if (currentIndex === 2) {
      setPndDrv((prevData) =>
        prevData.map((row, idx) =>
          idx === index ? { ...row, busNO: value } : row
        )
      );

      // if search filter is active, also update the filteredData so the visible row reflects changes
      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row, idx) =>
            idx === index ? { ...row, busNO: value } : row
          )
        );
      }
    } else if (currentIndex === 3) {
      setPndBusNo((prevData) =>
        prevData.map((row, idx) =>
          idx === index ? { ...row, busNO: value } : row
        )
      );

      // if search filter is active, also update the filteredData so the visible row reflects changes
      if (filter) {
        setFilteredData((prevData) =>
          prevData.map((row, idx) =>
            idx === index ? { ...row, busNO: value } : row
          )
        );
      }
    }

    setShowBusList(false);
    setSelectBus(true);
  };

  const columns = [
    {
      name: (
        <div className="theadcol-flex">
          <span>Duty No</span>
        </div>
      ),
      selector: (row) => row.workno,
      sortable: true,
      cell: (row) => (
        <>
          <div className="routNo">
            <span>{row.workno}</span>
            <div className="duty-details">
              <div className="profiles">
                <div className="profile">
                  <span className="name">Duty No.</span>
                  <span className="desig">{row.workno}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">Before Rest Sr</span>
                  <span className="desig">{row.startSrNO}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">After Rest Sr</span>
                  <span className="desig">{row.afterSrNO}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">Turn Out</span>
                  <span className="desig">{row.turnOutPlace}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">After Rest</span>
                  <span className="desig">{row.afterRestOutInPlace}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">Rel Time</span>
                  <span className="desig">{row.relivingTime}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">End Time</span>
                  <span className="desig">{row.dutyEndTime}</span>
                </div>
              </div>
              <div className="profiles">
                <div className="profile">
                  <span className="name">Total Hours</span>
                  <span className="desig">{row.dutyHourse}</span>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
      width: "115px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Driver</span>
        </div>
      ),
      selector: (row) => row.driverNo,
      cell: (row, index) => {
        const data1 = draggedDrvDatas.filter(
          (item) => item.workno === row.workno
        );
        const data2 = draggedCondDatas.filter(
          (item) => item.workno === row.workno
        );

        return (
          <div
            className={
              row.dutyAllot === "1" && row.driVla === "1" ? "crew" : "crew"
            }
            onDrop={(event) => onDropDrv(event, row)}
          >
            <div className="crew-pic">
              <span>
                <svg
                  width="37"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.4376 10.889C25.4376 15.8146 22.4622 20.0418 18.5001 20.0418C14.5349 20.0418 11.5626 15.8146 11.5626 10.8874C11.5626 5.96333 14.1218 3.0835 18.5001 3.0835C22.8784 3.0835 25.4376 5.96179 25.4376 10.889ZM6.32401 31.0524C6.91755 31.7585 9.47363 33.9168 18.5001 33.9168C27.5266 33.9168 30.0811 31.7585 30.6762 31.054C30.7314 30.9862 30.7722 30.908 30.796 30.8239C30.8199 30.7399 30.8263 30.6519 30.8149 30.5653C30.6793 29.2055 29.4552 23.1252 18.5001 23.1252C7.54501 23.1252 6.32093 29.2055 6.18372 30.5653C6.17255 30.652 6.17924 30.7401 6.20336 30.8241C6.22749 30.9081 6.26855 30.9848 6.32401 31.0524Z"
                    fill="#D2CDDA"
                  />
                </svg>
              </span>
            </div>
            <div className="crew-info">
              <div className="other-info">
                <div className="crew-code">
                  <div
                    className={
                      row.driverPresenty === "1" || data1.length > 0
                        ? "action active"
                        : "action"
                    }
                  >
                    {data1 && data1.length > 0 ? (
                      <>
                        <input
                          className="custom-input crew"
                          type="text"
                          value={data1[0].driverNo}
                          onFocus={() => {
                            setEdit(true);
                            setDutyLists((prevData) =>
                              prevData.map((row2) =>
                                row2.workno === row.workno
                                  ? { ...row2, driverNo: "" }
                                  : row2
                              )
                            );
                          }}
                          onBlur={() => {
                            setEdit(false);
                            fetchData();
                          }}
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              index,
                              "driverNo",
                              data1[0].driverNo
                            )
                          }
                        />
                      </>
                    ) : (
                      <>
                        <input
                          className="custom-input crew"
                          type="text"
                          value={row.driverNo}
                          onFocus={() => {
                            setEdit(true);
                            setDutyLists((prevData) =>
                              prevData.map((row2) =>
                                row2.workno === row.workno
                                  ? { ...row2, driverNo: "" }
                                  : row2
                              )
                            );
                          }}
                          onBlur={() => {
                            setEdit(false);
                            fetchData();
                          }}
                          onChange={(e) =>
                            handleInputChange(e, index, "driverNo", row.workno)
                          }
                        />
                      </>
                    )}
                  </div>
                  {(isDrvChange && changedDuty === row.workno) ||
                  (data1 && data1.length > 0) ? (
                    <button
                      className="transperent"
                      title="undo"
                      onClick={(e) => {
                        resetDrv(row.workno);
                      }}
                    >
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2697_3748)">
                            <path
                              d="M6.78125 9.6875C5.82325 9.6875 4.88676 9.40342 4.09021 8.87118C3.29366 8.33895 2.67282 7.58246 2.30621 6.69738C1.9396 5.8123 1.84368 4.83838 2.03057 3.89878C2.21747 2.95919 2.67879 2.09611 3.3562 1.4187C4.03361 0.741293 4.89669 0.279971 5.83628 0.0930735C6.77588 -0.0938237 7.7498 0.00209872 8.63488 0.368711C9.51996 0.735323 10.2764 1.35616 10.8087 2.15271C11.3409 2.94926 11.625 3.88575 11.625 4.84375C11.6235 6.12792 11.1126 7.35906 10.2046 8.2671C9.29656 9.17515 8.06542 9.68597 6.78125 9.6875ZM6.78125 1.9375C6.20645 1.9375 5.64456 2.10795 5.16663 2.42729C4.6887 2.74664 4.3162 3.20053 4.09623 3.73158C3.87626 4.26263 3.81871 4.84698 3.93085 5.41073C4.04298 5.97449 4.31978 6.49234 4.72622 6.89878C5.13267 7.30523 5.65051 7.58202 6.21427 7.69416C6.77803 7.8063 7.36238 7.74875 7.89343 7.52878C8.42448 7.30881 8.87837 6.93631 9.19771 6.45838C9.51706 5.98045 9.6875 5.41856 9.6875 4.84375C9.6875 4.07297 9.38131 3.33375 8.83628 2.78872C8.29126 2.2437 7.55204 1.9375 6.78125 1.9375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M3.87502 15.4998H1.93752C1.71419 15.4998 1.49771 15.4227 1.32471 15.2815C1.15171 15.1402 1.03281 14.9436 0.988145 14.7248L0.019395 9.88101C-0.0233394 9.67201 0.0041038 9.45476 0.0974659 9.26295C0.190828 9.07115 0.344888 8.91552 0.535739 8.82023L4.02324 7.07648C4.25383 6.96163 4.5206 6.94309 4.76487 7.02494C5.00913 7.10678 5.21088 7.28231 5.32572 7.5129C5.44057 7.74349 5.45911 8.01026 5.37726 8.25453C5.29542 8.49879 5.11989 8.70054 4.8893 8.81539L2.06346 10.223L2.73189 13.5623H3.87502C4.13195 13.5623 4.37835 13.6643 4.56003 13.846C4.7417 14.0277 4.84377 14.2741 4.84377 14.531C4.84377 14.7879 4.7417 15.0343 4.56003 15.216C4.37835 15.3977 4.13195 15.4998 3.87502 15.4998Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M11.625 15.5001H7.75C7.49307 15.5001 7.24667 15.398 7.06499 15.2164C6.88331 15.0347 6.78125 14.7883 6.78125 14.5314C6.78125 14.2744 6.88331 14.028 7.06499 13.8463C7.24667 13.6647 7.49307 13.5626 7.75 13.5626H10.8306L11.4991 10.2233L8.67322 8.81572C8.55841 8.75947 8.45587 8.68104 8.37151 8.58496C8.28716 8.48888 8.22266 8.37706 8.18173 8.25593C8.1408 8.13481 8.12425 8.00678 8.13304 7.87923C8.14182 7.75168 8.17577 7.62713 8.23292 7.51276C8.29007 7.39839 8.3693 7.29646 8.46603 7.21286C8.56276 7.12926 8.67509 7.06563 8.79653 7.02564C8.91797 6.98566 9.04612 6.97011 9.1736 6.97989C9.30108 6.98967 9.42536 7.02459 9.53928 7.08263L13.0268 8.82638C13.2165 8.92141 13.3698 9.0761 13.4631 9.26669C13.5563 9.45728 13.5845 9.67322 13.5431 9.88135L12.5744 14.7251C12.5297 14.9439 12.4108 15.1406 12.2378 15.2818C12.0648 15.423 11.8483 15.5001 11.625 15.5001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 25.1875C23.2608 25.1875 22.3243 24.9034 21.5277 24.3712C20.7312 23.8389 20.1103 23.0825 19.7437 22.1974C19.3771 21.3123 19.2812 20.3384 19.4681 19.3988C19.655 18.4592 20.1163 17.5961 20.7937 16.9187C21.4711 16.2413 22.3342 15.78 23.2738 15.5931C24.2134 15.4062 25.1873 15.5021 26.0724 15.8687C26.9575 16.2353 27.7139 16.8562 28.2462 17.6527C28.7784 18.4493 29.0625 19.3858 29.0625 20.3438C29.061 21.6279 28.5502 22.8591 27.6421 23.7671C26.7341 24.6752 25.5029 25.186 24.2188 25.1875ZM24.2188 17.4375C23.644 17.4375 23.0821 17.608 22.6041 17.9273C22.1262 18.2466 21.7537 18.7005 21.5337 19.2316C21.3138 19.7626 21.2562 20.347 21.3683 20.9107C21.4805 21.4745 21.7573 21.9923 22.1637 22.3988C22.5702 22.8052 23.088 23.082 23.6518 23.1942C24.2155 23.3063 24.7999 23.2487 25.3309 23.0288C25.862 22.8088 26.3159 22.4363 26.6352 21.9584C26.9546 21.4804 27.125 20.9186 27.125 20.3438C27.125 19.573 26.8188 18.8338 26.2738 18.2887C25.7288 17.7437 24.9895 17.4375 24.2188 17.4375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M21.3125 31.0001H19.375C19.1517 31.0001 18.9352 30.923 18.7622 30.7818C18.5892 30.6406 18.4703 30.4439 18.4257 30.2251L17.4569 25.3813C17.4151 25.1729 17.443 24.9565 17.5363 24.7655C17.6296 24.5745 17.7832 24.4195 17.9733 24.3244L21.4608 22.5807C21.5747 22.5226 21.699 22.4877 21.8264 22.4779C21.9539 22.4682 22.0821 22.4837 22.2035 22.5237C22.325 22.5637 22.4373 22.6273 22.534 22.7109C22.6307 22.7945 22.71 22.8964 22.7671 23.0108C22.8243 23.1252 22.8582 23.2497 22.867 23.3773C22.8758 23.5048 22.8592 23.6329 22.8183 23.754C22.7774 23.8751 22.7129 23.9869 22.6285 24.083C22.5442 24.1791 22.4416 24.2575 22.3268 24.3138L19.501 25.7233L20.1694 29.0626H21.3125C21.5695 29.0626 21.8159 29.1646 21.9976 29.3463C22.1792 29.528 22.2813 29.7744 22.2813 30.0313C22.2813 30.2883 22.1792 30.5347 21.9976 30.7163C21.8159 30.898 21.5695 31.0001 21.3125 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M29.0625 31.0001H25.1875C24.9306 31.0001 24.6842 30.898 24.5025 30.7164C24.3208 30.5347 24.2188 30.2883 24.2188 30.0314C24.2188 29.7744 24.3208 29.528 24.5025 29.3463C24.6842 29.1647 24.9306 29.0626 25.1875 29.0626H28.2681L28.9366 25.7233L26.1107 24.3157C25.9959 24.2595 25.8934 24.181 25.809 24.085C25.7247 23.9889 25.6602 23.8771 25.6192 23.7559C25.5783 23.6348 25.5617 23.5068 25.5705 23.3792C25.5793 23.2517 25.6133 23.1271 25.6704 23.0128C25.7276 22.8984 25.8068 22.7965 25.9035 22.7129C26.0003 22.6293 26.1126 22.5656 26.234 22.5256C26.3555 22.4857 26.4836 22.4701 26.6111 22.4799C26.7386 22.4897 26.8629 22.5246 26.9768 22.5826L30.4643 24.3264C30.654 24.4214 30.8073 24.5761 30.9006 24.7667C30.9938 24.9573 31.022 25.1732 30.9806 25.3814L30.0119 30.2251C29.9672 30.4439 29.8483 30.6406 29.6753 30.7818C29.5023 30.923 29.2858 31.0001 29.0625 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 13.5625C23.9618 13.5625 23.7154 13.4604 23.5337 13.2788C23.3521 13.0971 23.25 12.8507 23.25 12.5938V10.6562C23.2485 9.37208 22.7376 8.14095 21.8296 7.2329C20.9216 6.32485 19.6904 5.81404 18.4062 5.8125H16.4688C16.2118 5.8125 15.9654 5.71044 15.7837 5.52876C15.6021 5.34708 15.5 5.10068 15.5 4.84375C15.5 4.58682 15.6021 4.34042 15.7837 4.15874C15.9654 3.97706 16.2118 3.875 16.4688 3.875H18.4062C20.2041 3.87705 21.9278 4.59216 23.1991 5.86345C24.4703 7.13473 25.1854 8.85838 25.1875 10.6562V12.5938C25.1875 12.8507 25.0854 13.0971 24.9038 13.2788C24.7221 13.4604 24.4757 13.5625 24.2188 13.5625Z"
                              fill="#F98585"
                            />
                            <path
                              d="M16.4688 7.75018C16.2119 7.75013 15.9655 7.64803 15.7839 7.46634L13.8464 5.52884C13.6648 5.34717 13.5627 5.10081 13.5627 4.84393C13.5627 4.58706 13.6648 4.34069 13.8464 4.15903L15.7839 2.22153C15.8732 2.129 15.9801 2.0552 16.0983 2.00443C16.2165 1.95366 16.3436 1.92694 16.4723 1.92582C16.6009 1.9247 16.7285 1.94921 16.8475 1.99792C16.9666 2.04663 17.0747 2.11856 17.1657 2.20952C17.2567 2.30048 17.3286 2.40864 17.3773 2.5277C17.426 2.64675 17.4505 2.77432 17.4494 2.90295C17.4483 3.03158 17.4216 3.1587 17.3708 3.27689C17.32 3.39508 17.2462 3.50198 17.1537 3.59134L15.9011 4.84393L17.1537 6.09653C17.2891 6.23201 17.3814 6.4046 17.4187 6.59249C17.4561 6.78039 17.4369 6.97514 17.3636 7.15213C17.2903 7.32912 17.1662 7.4804 17.0069 7.58685C16.8476 7.6933 16.6604 7.75014 16.4688 7.75018Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 27.125H10.6562C9.37208 27.1235 8.14095 26.6126 7.2329 25.7046C6.32485 24.7966 5.81404 23.5654 5.8125 22.2812V18.4062C5.8125 18.1493 5.91456 17.9029 6.09624 17.7212C6.27792 17.5396 6.52432 17.4375 6.78125 17.4375C7.03818 17.4375 7.28458 17.5396 7.46626 17.7212C7.64794 17.9029 7.75 18.1493 7.75 18.4062V22.2812C7.75 23.052 8.05619 23.7913 8.60122 24.3363C9.14625 24.8813 9.88546 25.1875 10.6562 25.1875H12.5938C12.8507 25.1875 13.0971 25.2896 13.2788 25.4712C13.4604 25.6529 13.5625 25.8993 13.5625 26.1562C13.5625 26.4132 13.4604 26.6596 13.2788 26.8413C13.0971 27.0229 12.8507 27.125 12.5938 27.125Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 29.0623C12.4022 29.0623 12.215 29.0054 12.0557 28.899C11.8964 28.7925 11.7723 28.6413 11.699 28.4643C11.6257 28.2873 11.6065 28.0925 11.6438 27.9046C11.6812 27.7167 11.7734 27.5441 11.9089 27.4087L13.1615 26.1561L11.9089 24.9035C11.7324 24.7208 11.6348 24.4761 11.637 24.2221C11.6392 23.968 11.7411 23.7251 11.9207 23.5455C12.1003 23.3658 12.3433 23.264 12.5973 23.2618C12.8513 23.2595 13.096 23.3572 13.2787 23.5337L15.2162 25.4712C15.3978 25.6528 15.4998 25.8992 15.4998 26.1561C15.4998 26.4129 15.3978 26.6593 15.2162 26.841L13.2787 28.7785C13.0971 28.9602 12.8507 29.0623 12.5938 29.0623Z"
                              fill="#F98585"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2697_3748">
                              <rect width="31" height="31" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  ) : null}
                  <DutyDetails
                    data={row}
                    depo={depo}
                    fetchData={fetchData}
                    data1={data1}
                    data2={data2}
                    isDrv={true}
                    isCond={false}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "175px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Conductor </span>
        </div>
      ),
      selector: (row) => row.conductorNo,
      cell: (row, index) => {
        const data1 = draggedDrvDatas.filter(
          (item) => item.workno === row.workno
        );
        const data2 = draggedCondDatas.filter(
          (item) => item.workno === row.workno
        );
        return (
          <div className={"crew"} onDrop={(event) => onDropCon(event, row)}>
            <div className="crew-pic">
              <span>
                <svg
                  width="37"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.4376 10.889C25.4376 15.8146 22.4622 20.0418 18.5001 20.0418C14.5349 20.0418 11.5626 15.8146 11.5626 10.8874C11.5626 5.96333 14.1218 3.0835 18.5001 3.0835C22.8784 3.0835 25.4376 5.96179 25.4376 10.889ZM6.32401 31.0524C6.91755 31.7585 9.47363 33.9168 18.5001 33.9168C27.5266 33.9168 30.0811 31.7585 30.6762 31.054C30.7314 30.9862 30.7722 30.908 30.796 30.8239C30.8199 30.7399 30.8263 30.6519 30.8149 30.5653C30.6793 29.2055 29.4552 23.1252 18.5001 23.1252C7.54501 23.1252 6.32093 29.2055 6.18372 30.5653C6.17255 30.652 6.17924 30.7401 6.20336 30.8241C6.22749 30.9081 6.26855 30.9848 6.32401 31.0524Z"
                    fill="#D2CDDA"
                  />
                </svg>
              </span>
            </div>
            <div className="crew-info">
              <div className="other-info">
                <div className="crew-code">
                  <div
                    className={
                      row.conductorPresenty === "1" ||
                      data2.length > 0 ||
                      currentIndex === 2
                        ? "action active"
                        : "action"
                    }
                  >
                    <span>
                      {data2 && data2.length > 0 ? (
                        <>
                          <input
                            className="custom-input crew"
                            type="text"
                            value={data2[0].condNo}
                            onFocus={() => {
                              setEdit(true);
                              setDutyLists((prevData) =>
                                prevData.map((row2) =>
                                  row2.workno === row.workno
                                    ? { ...row2, conductorNo: "" }
                                    : row2
                                )
                              );
                            }}
                            onBlur={() => {
                              setEdit(false);
                              fetchData();
                            }}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                index,
                                "conductorNo",
                                data2[0].condNo
                              )
                            }
                          />
                        </>
                      ) : (
                        <>
                          <input
                            className="custom-input crew"
                            type="text"
                            value={row.conductorNo}
                            onFocus={() => {
                              setEdit(true);
                              setDutyLists((prevData) =>
                                prevData.map((row2) =>
                                  row2.workno === row.workno
                                    ? { ...row2, conductorNo: "" }
                                    : row2
                                )
                              );
                            }}
                            onBlur={() => {
                              setEdit(false);
                              fetchData();
                            }}
                            onChange={(e) =>
                              handleInputChange(
                                e,
                                index,
                                "conductorNo",
                                row.workno
                              )
                            }
                          />
                        </>
                      )}
                    </span>
                  </div>
                  {(isCondChange && changedDuty === row.workno) ||
                  (data2 && data2.length > 0) ? (
                    <button
                      className="transperent"
                      title="undo"
                      onClick={(e) => {
                        resetCond(row.workno);
                      }}
                    >
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2697_3748)">
                            <path
                              d="M6.78125 9.6875C5.82325 9.6875 4.88676 9.40342 4.09021 8.87118C3.29366 8.33895 2.67282 7.58246 2.30621 6.69738C1.9396 5.8123 1.84368 4.83838 2.03057 3.89878C2.21747 2.95919 2.67879 2.09611 3.3562 1.4187C4.03361 0.741293 4.89669 0.279971 5.83628 0.0930735C6.77588 -0.0938237 7.7498 0.00209872 8.63488 0.368711C9.51996 0.735323 10.2764 1.35616 10.8087 2.15271C11.3409 2.94926 11.625 3.88575 11.625 4.84375C11.6235 6.12792 11.1126 7.35906 10.2046 8.2671C9.29656 9.17515 8.06542 9.68597 6.78125 9.6875ZM6.78125 1.9375C6.20645 1.9375 5.64456 2.10795 5.16663 2.42729C4.6887 2.74664 4.3162 3.20053 4.09623 3.73158C3.87626 4.26263 3.81871 4.84698 3.93085 5.41073C4.04298 5.97449 4.31978 6.49234 4.72622 6.89878C5.13267 7.30523 5.65051 7.58202 6.21427 7.69416C6.77803 7.8063 7.36238 7.74875 7.89343 7.52878C8.42448 7.30881 8.87837 6.93631 9.19771 6.45838C9.51706 5.98045 9.6875 5.41856 9.6875 4.84375C9.6875 4.07297 9.38131 3.33375 8.83628 2.78872C8.29126 2.2437 7.55204 1.9375 6.78125 1.9375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M3.87502 15.4998H1.93752C1.71419 15.4998 1.49771 15.4227 1.32471 15.2815C1.15171 15.1402 1.03281 14.9436 0.988145 14.7248L0.019395 9.88101C-0.0233394 9.67201 0.0041038 9.45476 0.0974659 9.26295C0.190828 9.07115 0.344888 8.91552 0.535739 8.82023L4.02324 7.07648C4.25383 6.96163 4.5206 6.94309 4.76487 7.02494C5.00913 7.10678 5.21088 7.28231 5.32572 7.5129C5.44057 7.74349 5.45911 8.01026 5.37726 8.25453C5.29542 8.49879 5.11989 8.70054 4.8893 8.81539L2.06346 10.223L2.73189 13.5623H3.87502C4.13195 13.5623 4.37835 13.6643 4.56003 13.846C4.7417 14.0277 4.84377 14.2741 4.84377 14.531C4.84377 14.7879 4.7417 15.0343 4.56003 15.216C4.37835 15.3977 4.13195 15.4998 3.87502 15.4998Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M11.625 15.5001H7.75C7.49307 15.5001 7.24667 15.398 7.06499 15.2164C6.88331 15.0347 6.78125 14.7883 6.78125 14.5314C6.78125 14.2744 6.88331 14.028 7.06499 13.8463C7.24667 13.6647 7.49307 13.5626 7.75 13.5626H10.8306L11.4991 10.2233L8.67322 8.81572C8.55841 8.75947 8.45587 8.68104 8.37151 8.58496C8.28716 8.48888 8.22266 8.37706 8.18173 8.25593C8.1408 8.13481 8.12425 8.00678 8.13304 7.87923C8.14182 7.75168 8.17577 7.62713 8.23292 7.51276C8.29007 7.39839 8.3693 7.29646 8.46603 7.21286C8.56276 7.12926 8.67509 7.06563 8.79653 7.02564C8.91797 6.98566 9.04612 6.97011 9.1736 6.97989C9.30108 6.98967 9.42536 7.02459 9.53928 7.08263L13.0268 8.82638C13.2165 8.92141 13.3698 9.0761 13.4631 9.26669C13.5563 9.45728 13.5845 9.67322 13.5431 9.88135L12.5744 14.7251C12.5297 14.9439 12.4108 15.1406 12.2378 15.2818C12.0648 15.423 11.8483 15.5001 11.625 15.5001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 25.1875C23.2608 25.1875 22.3243 24.9034 21.5277 24.3712C20.7312 23.8389 20.1103 23.0825 19.7437 22.1974C19.3771 21.3123 19.2812 20.3384 19.4681 19.3988C19.655 18.4592 20.1163 17.5961 20.7937 16.9187C21.4711 16.2413 22.3342 15.78 23.2738 15.5931C24.2134 15.4062 25.1873 15.5021 26.0724 15.8687C26.9575 16.2353 27.7139 16.8562 28.2462 17.6527C28.7784 18.4493 29.0625 19.3858 29.0625 20.3438C29.061 21.6279 28.5502 22.8591 27.6421 23.7671C26.7341 24.6752 25.5029 25.186 24.2188 25.1875ZM24.2188 17.4375C23.644 17.4375 23.0821 17.608 22.6041 17.9273C22.1262 18.2466 21.7537 18.7005 21.5337 19.2316C21.3138 19.7626 21.2562 20.347 21.3683 20.9107C21.4805 21.4745 21.7573 21.9923 22.1637 22.3988C22.5702 22.8052 23.088 23.082 23.6518 23.1942C24.2155 23.3063 24.7999 23.2487 25.3309 23.0288C25.862 22.8088 26.3159 22.4363 26.6352 21.9584C26.9546 21.4804 27.125 20.9186 27.125 20.3438C27.125 19.573 26.8188 18.8338 26.2738 18.2887C25.7288 17.7437 24.9895 17.4375 24.2188 17.4375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M21.3125 31.0001H19.375C19.1517 31.0001 18.9352 30.923 18.7622 30.7818C18.5892 30.6406 18.4703 30.4439 18.4257 30.2251L17.4569 25.3813C17.4151 25.1729 17.443 24.9565 17.5363 24.7655C17.6296 24.5745 17.7832 24.4195 17.9733 24.3244L21.4608 22.5807C21.5747 22.5226 21.699 22.4877 21.8264 22.4779C21.9539 22.4682 22.0821 22.4837 22.2035 22.5237C22.325 22.5637 22.4373 22.6273 22.534 22.7109C22.6307 22.7945 22.71 22.8964 22.7671 23.0108C22.8243 23.1252 22.8582 23.2497 22.867 23.3773C22.8758 23.5048 22.8592 23.6329 22.8183 23.754C22.7774 23.8751 22.7129 23.9869 22.6285 24.083C22.5442 24.1791 22.4416 24.2575 22.3268 24.3138L19.501 25.7233L20.1694 29.0626H21.3125C21.5695 29.0626 21.8159 29.1646 21.9976 29.3463C22.1792 29.528 22.2813 29.7744 22.2813 30.0313C22.2813 30.2883 22.1792 30.5347 21.9976 30.7163C21.8159 30.898 21.5695 31.0001 21.3125 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M29.0625 31.0001H25.1875C24.9306 31.0001 24.6842 30.898 24.5025 30.7164C24.3208 30.5347 24.2188 30.2883 24.2188 30.0314C24.2188 29.7744 24.3208 29.528 24.5025 29.3463C24.6842 29.1647 24.9306 29.0626 25.1875 29.0626H28.2681L28.9366 25.7233L26.1107 24.3157C25.9959 24.2595 25.8934 24.181 25.809 24.085C25.7247 23.9889 25.6602 23.8771 25.6192 23.7559C25.5783 23.6348 25.5617 23.5068 25.5705 23.3792C25.5793 23.2517 25.6133 23.1271 25.6704 23.0128C25.7276 22.8984 25.8068 22.7965 25.9035 22.7129C26.0003 22.6293 26.1126 22.5656 26.234 22.5256C26.3555 22.4857 26.4836 22.4701 26.6111 22.4799C26.7386 22.4897 26.8629 22.5246 26.9768 22.5826L30.4643 24.3264C30.654 24.4214 30.8073 24.5761 30.9006 24.7667C30.9938 24.9573 31.022 25.1732 30.9806 25.3814L30.0119 30.2251C29.9672 30.4439 29.8483 30.6406 29.6753 30.7818C29.5023 30.923 29.2858 31.0001 29.0625 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 13.5625C23.9618 13.5625 23.7154 13.4604 23.5337 13.2788C23.3521 13.0971 23.25 12.8507 23.25 12.5938V10.6562C23.2485 9.37208 22.7376 8.14095 21.8296 7.2329C20.9216 6.32485 19.6904 5.81404 18.4062 5.8125H16.4688C16.2118 5.8125 15.9654 5.71044 15.7837 5.52876C15.6021 5.34708 15.5 5.10068 15.5 4.84375C15.5 4.58682 15.6021 4.34042 15.7837 4.15874C15.9654 3.97706 16.2118 3.875 16.4688 3.875H18.4062C20.2041 3.87705 21.9278 4.59216 23.1991 5.86345C24.4703 7.13473 25.1854 8.85838 25.1875 10.6562V12.5938C25.1875 12.8507 25.0854 13.0971 24.9038 13.2788C24.7221 13.4604 24.4757 13.5625 24.2188 13.5625Z"
                              fill="#F98585"
                            />
                            <path
                              d="M16.4688 7.75018C16.2119 7.75013 15.9655 7.64803 15.7839 7.46634L13.8464 5.52884C13.6648 5.34717 13.5627 5.10081 13.5627 4.84393C13.5627 4.58706 13.6648 4.34069 13.8464 4.15903L15.7839 2.22153C15.8732 2.129 15.9801 2.0552 16.0983 2.00443C16.2165 1.95366 16.3436 1.92694 16.4723 1.92582C16.6009 1.9247 16.7285 1.94921 16.8475 1.99792C16.9666 2.04663 17.0747 2.11856 17.1657 2.20952C17.2567 2.30048 17.3286 2.40864 17.3773 2.5277C17.426 2.64675 17.4505 2.77432 17.4494 2.90295C17.4483 3.03158 17.4216 3.1587 17.3708 3.27689C17.32 3.39508 17.2462 3.50198 17.1537 3.59134L15.9011 4.84393L17.1537 6.09653C17.2891 6.23201 17.3814 6.4046 17.4187 6.59249C17.4561 6.78039 17.4369 6.97514 17.3636 7.15213C17.2903 7.32912 17.1662 7.4804 17.0069 7.58685C16.8476 7.6933 16.6604 7.75014 16.4688 7.75018Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 27.125H10.6562C9.37208 27.1235 8.14095 26.6126 7.2329 25.7046C6.32485 24.7966 5.81404 23.5654 5.8125 22.2812V18.4062C5.8125 18.1493 5.91456 17.9029 6.09624 17.7212C6.27792 17.5396 6.52432 17.4375 6.78125 17.4375C7.03818 17.4375 7.28458 17.5396 7.46626 17.7212C7.64794 17.9029 7.75 18.1493 7.75 18.4062V22.2812C7.75 23.052 8.05619 23.7913 8.60122 24.3363C9.14625 24.8813 9.88546 25.1875 10.6562 25.1875H12.5938C12.8507 25.1875 13.0971 25.2896 13.2788 25.4712C13.4604 25.6529 13.5625 25.8993 13.5625 26.1562C13.5625 26.4132 13.4604 26.6596 13.2788 26.8413C13.0971 27.0229 12.8507 27.125 12.5938 27.125Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 29.0623C12.4022 29.0623 12.215 29.0054 12.0557 28.899C11.8964 28.7925 11.7723 28.6413 11.699 28.4643C11.6257 28.2873 11.6065 28.0925 11.6438 27.9046C11.6812 27.7167 11.7734 27.5441 11.9089 27.4087L13.1615 26.1561L11.9089 24.9035C11.7324 24.7208 11.6348 24.4761 11.637 24.2221C11.6392 23.968 11.7411 23.7251 11.9207 23.5455C12.1003 23.3658 12.3433 23.264 12.5973 23.2618C12.8513 23.2595 13.096 23.3572 13.2787 23.5337L15.2162 25.4712C15.3978 25.6528 15.4998 25.8992 15.4998 26.1561C15.4998 26.4129 15.3978 26.6593 15.2162 26.841L13.2787 28.7785C13.0971 28.9602 12.8507 29.0623 12.5938 29.0623Z"
                              fill="#F98585"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2697_3748">
                              <rect width="31" height="31" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  ) : null}
                  <DutyDetails
                    data={row}
                    depo={depo}
                    fetchData={fetchData}
                    data1={data1}
                    data2={data2}
                    isDrv={false}
                    isCond={true}
                    currentIndex={currentIndex}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "175px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Vehicle No.</span>
        </div>
      ),
      selector: (row) => row.busNO,
      cell: (row, index) => (
        <>
          <div className="busno">
            <input
              className="custom-input"
              style={{ width: "100px" }}
              name="busNO"
              type="text"
              value={row.busNO}
              onChange={(e) => handleSelectBusNo(e, index, row.workno)}
              autoComplete="off"
            />
          </div>
          {row.workno === editDutyNo && showBusList && busList.length > 0 && (
            <>
              <div className="vech-list">
                {Array.isArray(busList)
                  ? busList.map((item) => {
                      return (
                        <>
                          <button
                            className="bus-item"
                            onClick={(e) => {
                              handleSelect(e, index, item.busNo);
                            }}
                          >
                            {item.busNo}
                          </button>
                        </>
                      );
                    })
                  : null}
              </div>
            </>
          )}
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Delay Reason</span>
        </div>
      ),
      selector: (row) => row.delayReason,
      cell: (row, index) => (
        <>
          {row.dutyAllot === "1" && row.busNO !== "NA" && currentIndex === 4 ? (
            <>
              <span>{row.delayReason}</span>
            </>
          ) : (
            <>
              {" "}
              <div className="busno">
                <select
                  name="delayReason"
                  id="delayReason"
                  value={row.delayReason}
                  onChange={(e) =>
                    handleInputChange(e, index, "delayReason", row.workno)
                  }
                >
                  <option value="14">Computer</option>
                  <option value="1/1">Driver</option>
                  <option value="1/2">Conductor</option>
                  <option value="2">Bus</option>
                  <option value="8">Scheduled Suspend</option>
                  <option selected value="9">
                    No Delay
                  </option>
                </select>
              </div>
            </>
          )}
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Start Time</span>
        </div>
      ),
      selector: (row) => row.dutyStartTime,
      cell: (row) => (
        <>
          <div className="">
            {row.dutyStartTime && row.dutyStartTime.replace(".", ":")}
          </div>
        </>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>On Bus Time</span>
        </div>
      ),
      selector: (row) => row.onBusTime,
      cell: (row) => (
        <>
          <div className="">
            {row.onBusTime && row.onBusTime.replace(".", ":")}
          </div>
        </>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span></span>
          <span>Action</span>
        </div>
      ),
      selector: (row) => row.workno,
      cell: (row) => {
        return (
          <>
            <div className="d-flex gap-2">
              <div className="crew-action">
                <button
                  className="transperent"
                  onClick={(e) => {
                    setDutyData(row);
                    setShow2(true);
                  }}
                  title="Save Changes"
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-upload"
                      viewBox="0 0 16 16"
                    >
                      <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                      <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                    </svg>
                  </span>
                </button>
              </div>
              <div className="">
                <button
                  className="transperent"
                  title="Cancel Duty"
                  onClick={() => {
                    cancelDuty(row);
                    // setShow6(true);
                    // setDutyData(row);
                  }}
                >
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-x-lg"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </>
        );
      },
      sortable: true,
      width: "100px",
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => String(row.dutyAllot) === "1",
      style: {
        backgroundColor: "#93D5A0 !important",
      },
    },
  ];

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();
    const data =
      currentIndex === 0
        ? dutyLists
        : currentIndex === 1
        ? pndCond
        : currentIndex === 2
        ? pndDrv
        : currentIndex === 3
        ? pndBusNo
        : null;

    if (currentIndex === 6) {
      const filteredData = data.filter(
        (row) =>
          (row.workno &&
            row.workno.replace(/\s+/g, "").toLowerCase() === keyword) ||
          (row.conductorNo &&
            row.conductorNo.replace(/\s+/g, "").toLowerCase() === keyword) ||
          (row.driverNo &&
            row.driverNo.replace(/\s+/g, "").toLowerCase() === keyword)
        // (row.dutyTime && row.dutyTime.toLowerCase().includes(keyword))
      );
      if (keyword.length > 0) {
        setFilter(true);
      } else {
        setFilter(false);
      }
      setFilteredData(filteredData);
    } else {
      const filteredData = data.filter(
        (row) =>
          (row.workno &&
            row.workno.replace(/\s+/g, "").toLowerCase() === keyword) ||
          (row.conductorNo &&
            row.conductorNo.replace(/\s+/g, "").toLowerCase() === keyword) ||
          (row.driverNo &&
            row.driverNo.replace(/\s+/g, "").toLowerCase() === keyword)
        // (row.dutyTime && row.dutyTime.toLowerCase().includes(keyword))
      );
      if (keyword.length > 0) {
        setFilter(true);
      } else {
        setFilter(false);
      }
      setFilteredData(filteredData);
    }
  };

  const handleSearch2 = (e) => {
    setSearch2(e.target.value);
    const keyword = e.target.value.toLowerCase();

    if (keyword.length > 0) {
      setFilter2(true);
    } else {
      setFilter2(false);
    }

    const drvDatas = filter2 ? filteredDataDrv : drvList;

    const condDatas = filter2 ? filteredDataCond : condList;

    const allCrewData = drvDatas.concat(condDatas);

    // console.log("allCrewData", allCrewData);

    const filteredData = allCrewData.filter(
      (row) =>
        (row.empname && row.empname.toLowerCase().includes(keyword)) ||
        (row.empcode && row.empcode.toLowerCase().includes(keyword))
    );

    // console.log(filteredData);

    const drvData = filteredData.filter(
      (item) => item.designation === "Driver"
    );
    const condData = filteredData.filter(
      (item) => item.designation === "Conductor"
    );

    setFilteredDataDrv(drvData);
    setFilteredDataCond(condData);
  };

  const handleChecked = (e) => {
    setChecked(e.target.value);
    setShow(false);
    getDrvList(e.target.value);
  };

  // console.log("filter2", filteredDataCond)

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = today.getFullYear();

  let formattedDate = `${year}-${month}-${day}`;

  const updateDuty = () => {
    const data1 = draggedDrvDatas.filter(
      (item) => item.workno === dutyData.workno
    );
    const data2 = draggedCondDatas.filter(
      (item) => item.workno === dutyData.workno
    );

    const condPresent =
      data2 && data2.length > 0 ? "1" : dutyData.conductorPresenty;
    const drvPresent =
      data1 && data1.length > 0 ? "1" : dutyData.driverPresenty;

    const flag =
      condPresent === "1" && drvPresent === "1"
        ? "1"
        : condPresent === "1" && drvPresent === "0"
        ? "0"
        : "0";

    const payload = {
      busNo:
        condPresent === "1" && drvPresent === "1" && selectBus
          ? dutyData.busNO
          : "NA",
      dutyNo: dutyData.workno,
      driverNO:
        data1 && data1.length > 0 && drvPresent === "1"
          ? data1[0].driverNo
          : drvPresent === "1"
          ? dutyData.driverNo
          : "",
      conductorNo:
        data2 && data2.length > 0 && condPresent === "1"
          ? data2[0].condNo
          : condPresent === "1"
          ? dutyData.conductorNo
          : "",
      transactiondate: formattedDate,
      userId: "1",
      flag: flag,
      locID: "10",
      contrillerId: user && user.controllerId,
      narration: "",
      delayReason: dutyData.delayReason,
      shift: "m",
      timeTo: dutyData.dutyStartTime,
    };

    console.log(payload);

    // console.log("currentIndex", currentIndex);
    // console.log("condPresent", condPresent);
    // console.log("drvPresent", drvPresent);
    // console.log("selectBus", selectBus);

    if (!showBusList) {
      if (selectBus && condPresent === "1" && drvPresent === "1") {
        DutyPostingService.updateDuty(payload)
          .then((resp) => {
            if (resp.data) {
              const message = (
                <>
                  <div className="d-flex flex-column">
                    <div>चालक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.</div>
                    <div>Driver code is already added to another duty.</div>
                  </div>
                </>
              );

              toast.success("Duty Updated Successfully", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setShow2(false);
              fetchData();
              fetchBusAllotDuty();
              fetchAllocatedDuty();
              fetchCanceledDuty();
              getDrvList("1");
              setEdit(false);

              // setTimeout(() => {
              //   window.location.reload();
              // }, 3000);
            }
          })
          .catch((e) => console.log(e));
      } else if (
        currentIndex === 0 &&
        (condPresent === "1" || drvPresent === "1")
      ) {
        DutyPostingService.updateDuty(payload)
          .then((resp) => {
            if (resp.data) {
              toast.success("Duty Updated Successfully", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setShow2(false);
              fetchData();
              fetchBusAllotDuty();
              fetchAllocatedDuty();
              fetchCanceledDuty();
              getDrvList("1");
              setEdit(false);

              // setTimeout(() => {
              //   window.location.reload();
              // }, 3000);
            }
          })
          .catch((e) => console.log(e));
        // alert("update duty");
      } else if (
        (currentIndex === 1 || currentIndex === 2) &&
        condPresent === "1" &&
        drvPresent === "1"
      ) {
        DutyPostingService.updateDuty(payload)
          .then((resp) => {
            if (resp.data) {
              toast.success("Duty Updated successfully", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setShow2(false);
              fetchData();
              fetchBusAllotDuty();
              fetchAllocatedDuty();
              fetchCanceledDuty();
              getDrvList("1");
              setEdit(false);

              // setTimeout(() => {
              //   window.location.reload();
              // }, 3000);
            }
          })
          .catch((e) => console.log(e));
        // alert("update duty");
      } else if (
        currentIndex === 1 &&
        (condPresent !== "1" || drvPresent !== "1")
      ) {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>वाहक उपस्थित नाही. कृपया वाट पहा किंवा बदला!</div>
              <div>Conductor is not present. Please wait or change it!</div>
            </div>
          </>
        );

        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShow2(false);
        fetchData();
      } else if (
        currentIndex === 2 &&
        (condPresent !== "1" || drvPresent !== "1")
      ) {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>चालक उपस्थित नाही. कृपया वाट पहा किंवा बदला!</div>
              <div>Driver is not present. Please wait or change it!</div>
            </div>
          </>
        );

        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShow2(false);
        fetchData();
      } else if (
        currentIndex === 3 &&
        (condPresent === "1" || drvPresent === "1") &&
        selectBus === false
      ) {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>ड्युटी अपडेट करण्यासाठी कृपया बस नंबर निवडा!</div>
              <div>Please select bus number to update duty!</div>
            </div>
          </>
        );

        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShow2(false);
        fetchData();
      } else {
        toast.warn("Please change/select any column to update this duty!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setShow2(false);
        fetchData();
      }
    } else {
      toast.warn("Please select bus no. to update duty", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setShow2(false);
      fetchData();
    }
  };

  const [draggedCondDatas, setDraggedCondDatas] = useState(() => {
    const data = localStorage.getItem("draggedCondData");
    return data ? JSON.parse(data) : [];
  });

  const [draggedDrvDatas, setDraggedDrvDatas] = useState(() => {
    const data = localStorage.getItem("draggedDrvData");
    return data ? JSON.parse(data) : [];
  });

  // Update Duty Conductor Function
  const updateDutyCon = () => {
    const draggedCondData = JSON.parse(localStorage.getItem("draggedCondData"));
    if (
      draggedCondData &&
      draggedCondData.filter(
        (item) => item.condNo === selectedCon && item.workno !== dutyData.workno
      ).length > 0
    ) {
      toast.warn("Conductor code is already added to another duty", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (
      draggedCondData.filter(
        (item) => item.condNo === selectedCon && item.workno === dutyData.workno
      ).length > 0
    ) {
      const newArr = dutyLists.map((item2, idx) => {
        if (dutyData.workno === item2.workno) {
          return { ...item2, conductorNo: selectedCon, conductorPresenty: "1" };
        }
        return item2;
      });
      setDutyLists(newArr);
      setShow3(false);
      setIsCondChange(true);
      setChangedDuty(dutyData.workno);
    } else {
      const newArr = dutyLists.map((item2, idx) => {
        if (dutyData.workno === item2.workno) {
          return { ...item2, conductorNo: selectedCon, conductorPresenty: "1" };
        }
        return item2;
      });
      setDutyLists(newArr);
      setShow3(false);
      setIsCondChange(true);
      setChangedDuty(dutyData.workno);
      setDraggedCondDatas((prevValues) => {
        const exists = prevValues.some(
          (item) => item.workno === dutyData.workno
        );
        if (exists) {
          return prevValues.map((item) =>
            item.workno === dutyData.workno
              ? { ...item, condNo: selectedCon }
              : item
          );
        } else {
          return [
            ...prevValues,
            {
              workno: dutyData.workno,
              condNo: selectedCon,
            },
          ];
        }
      });
    }
  };

  // Update Duty Driver Function
  const updateDutyDrv = () => {
    const draggedDrvData = JSON.parse(localStorage.getItem("draggedDrvData"));
    if (
      draggedDrvData &&
      draggedDrvData.filter(
        (item) =>
          item.driverNo === selectedDrv && item.workno !== dutyData.workno
      ).length > 0
    ) {
      toast.warn("Driver code is already added to another duty", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      const newArr = dutyLists.map((item2, idx) => {
        if (dutyData.workno === item2.workno) {
          return { ...item2, driverNo: selectedDrv, driverPresenty: "1" };
        }
        return item2;
      });
      setDutyLists(newArr);
      setShow4(false);
      setIsDrvChange(true);
      setChangedDuty(dutyData.workno);
      setDraggedDrvDatas((prevValues) => {
        const exists = prevValues.some(
          (item) => item.workno === dutyData.workno
        );
        if (exists) {
          return prevValues.map((item) =>
            item.workno === dutyData.workno
              ? { ...item, driverNo: selectedDrv }
              : item
          );
        } else {
          return [
            ...prevValues,
            {
              workno: dutyData.workno,
              driverNo: selectedDrv,
            },
          ];
        }
      });
    }
  };

  // Save dragged conductor data to localStorage
  useEffect(() => {
    localStorage.setItem("draggedCondData", JSON.stringify(draggedCondDatas));
  }, [draggedCondDatas]);

  // Save dragged driver data to localStorage
  useEffect(() => {
    localStorage.setItem("draggedDrvData", JSON.stringify(draggedDrvDatas));
  }, [draggedDrvDatas]);

  // reset dragged / manually added driver or conductor data
  const resetDrv = (workno) => {
    setDraggedDrvDatas((prevValues) =>
      prevValues.filter((item) => item.workno !== workno)
    );
    fetchData();
    setIsDrvChange(false);
  };
  const resetCond = (workno) => {
    setDraggedCondDatas((prevValues) =>
      prevValues.filter((item) => item.workno !== workno)
    );
    fetchData();
    setIsCondChange(false);
  };

  // clear dragged data after 1 minute from localStorage
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDraggedCondDatas([]);
      setDraggedDrvDatas([]);
      localStorage.removeItem("draggedCondData");
      localStorage.removeItem("draggedDrvData");
      setIsDrvChange(false);
      setIsCondChange(false);
    }, 60000);

    return () => clearTimeout(timeout);
  }, []);

  // Cancel Duty Function
  const cancelDuty = (dutyData) => {
    if (dutyData.delayReason !== "9" && reasonChange) {
      const payload = {
        busNo: "NA",
        dutyNo: dutyData.workno,
        driverNO: "1",
        conductorNo: "1",
        transactiondate: formattedDate,
        userId: "1",
        flag: "2",
        locID: "10",
        contrillerId: user && user.controllerId,
        narration: "",
        delayReason: dutyData.delayReason,
        shift: "m",
        timeTo: dutyData.dutyStartTime,
      };

      // console.log(payload);

      DutyPostingService.updateDuty(payload)
        .then((resp) => {
          if (resp.data) {
            toast.success("Duty Cancelled successfully", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setShow6(false);
            fetchData();
            fetchCanceledDuty();

            // setTimeout(() => {
            //   window.location.reload();
            // }, 3000);
          }
        })
        .catch((e) => console.log(e));
    } else {
      toast.warn("Please select proper reason", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  // Handle file change for uploading crew photos
  const handleFileChange = (e, traycode) => {
    const file = e.target.files[0];
    // setSelectedFile(file);
    // console.log("Selected file:", file);

    const formData = new FormData();
    formData.append("userId", traycode);
    formData.append("imgfile", file);

    DutyPostingService.savePhotoWithUser(formData)
      .then((resp) => {
        // console.log(resp.data);
      })
      .catch((e) => console.log(e));
  };

  // Assign Double Duty Function
  const assignDoubleDuty = () => {
    const payload = {
      empType: empType,
      empCode: dutyData.empcode,
    };

    DutyPostingService.assignDblDutyAllocation(payload)
      .then((resp) => {
        if (resp.data) {
          toast.success("Double Duty Assigned successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          fetchData();
          setShow7(false);
          setEmpType("");
        }
      })
      .catch((e) => console.log(e));
  };

  const refreshData = () => {
    fetchData();
    fetchBusAllotDuty();
    fetchAllocatedDuty();
    fetchCanceledDuty();
    getDrvList("1");
  }

  return (
    <>
      <div className="dutyList-flex ps-3">
        <div className="left-flex">
          <ToastContainer />
          <div className="mt-3">
            <div className="cheader">
              <div className="flex pb-2">
                <div className="date">
                  <strong>Daily Posting</strong>
                </div>

                <div className="date">
                  <strong>
                    {moment(new Date(currentDate)).format("D MMM YYYY")}
                  </strong>
                </div>

                <div className="date">
                  <strong>Posting Book No. {user.posting}</strong>
                </div>
                <div className="date">
                  <strong>Controller - {user.controllerName}</strong>
                </div>
                {/* <button onClick={scrollToBottom}>Scroll Table Data to Bottom</button> */}
              </div>
            </div>
            <Tabs>
              <TabList>
                <Tab onClick={() => handleTabClick(0)}>
                  Scheduled <strong>{dutyLists.length}</strong>
                </Tab>
                <Tab onClick={() => handleTabClick(1)}>
                  <span>
                    Pending Conductors <strong>{pndCond.length}</strong>
                  </span>
                </Tab>
                <Tab onClick={() => handleTabClick(2)}>
                  <span>
                    Pending Drivers <strong>{pndDrv.length}</strong>
                  </span>
                </Tab>
                <Tab onClick={() => handleTabClick(3)}>
                  <span>
                    Pending Bus Numbers <strong>{pndBusNo.length}</strong>
                  </span>
                </Tab>
                <Tab onClick={() => handleTabClick(4)}>
                  <span>
                    Posted Duty <strong>{allocatedDuty.length}</strong>
                  </span>
                </Tab>
                <Tab onClick={() => handleTabClick(5)}>
                  <span>
                    Canceled Duty <strong>{canceledDuty.length}</strong>
                  </span>
                </Tab>
                <Tab onClick={() => handleTabClick(5)}>
                  <span>
                    Extra Duty <strong>{extraDutyCount}</strong>
                  </span>
                </Tab>
                <button title="Refresh All Data" onClick={refreshData} className="transperent">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="currentColor"
                    class="bi bi-arrow-clockwise"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                    />
                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                  </svg>
                </button>
              </TabList>

              <TabPanel>
                <div className="search-bar">
                  <input
                    type="text"
                    placeholder="Click here to Search by Duty No./Driver or Conductor Code."
                    name="search"
                    value={search}
                    onChange={handleSearch}
                  />
                  <div className="search-icon">
                    <span>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                          stroke="#A79EB7"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="datatable">
                  <DataTable
                    columns={columns}
                    data={filter ? filteredData : dutyLists}
                    fixedHeader
                    conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="search-bar">
                  <input
                    type="text"
                    placeholder="Click here to Search by Duty No./Driver or Conductor Code."
                    name="search"
                    value={search}
                    onChange={handleSearch}
                  />
                  <div className="search-icon">
                    <span>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                          stroke="#A79EB7"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="datatable">
                  <DataTable
                    columns={columns}
                    data={filter ? filteredData : pndCond}
                    fixedHeader
                    // conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="search-bar">
                  <input
                    type="text"
                    placeholder="Click here to Search by Duty No./Driver or Conductor Code."
                    name="search"
                    value={search}
                    onChange={handleSearch}
                  />
                  <div className="search-icon">
                    <span>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                          stroke="#A79EB7"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="datatable">
                  <DataTable
                    columns={columns}
                    data={filter ? filteredData : pndDrv}
                    fixedHeader
                    // conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              </TabPanel>
              <TabPanel>
                <div className="search-bar">
                  <input
                    type="text"
                    placeholder="Click here to Search by Duty No./Driver or Conductor Code."
                    name="search"
                    value={search}
                    onChange={handleSearch}
                  />
                  <div className="search-icon">
                    <span>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                          stroke="#A79EB7"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="datatable">
                  <DataTable
                    columns={columns}
                    data={filter ? filteredData : pndBusNo}
                    fixedHeader
                    // conditionalRowStyles={conditionalRowStyles}
                  />
                </div>
              </TabPanel>
              <TabPanel>
                <AllocatedDuty
                  filter={filter}
                  filteredData={filteredData}
                  data={allocatedDuty}
                />
              </TabPanel>
              <TabPanel>
                <CanceledDuty
                  filter={filter}
                  filteredData={filteredData}
                  data={canceledDuty}
                  fetchExtraDutys={fetchExtraDutys}
                  extraDuty={extraDuty}
                />
              </TabPanel>
              <TabPanel>
                <ExtraDuty
                  depo={depo}
                  fetchExtraDutys={fetchExtraDutys}
                  extraDuty={extraDuty}
                  setExtraDuty={setExtraDuty}
                  draggedCondDatas={draggedCondDatas}
                  setDraggedCondDatas={setDraggedCondDatas}
                  draggedDrvDatas={draggedDrvDatas}
                  setDraggedDrvDatas={setDraggedDrvDatas}
                  getDrvList={getDrvList}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>

        <div className="crew-list">
          <div className="d-flex gap-2">
            <div className="search-bar mb-3">
              <input
                type="text"
                placeholder="Search Driver/Conductor name/ID"
                value={search2}
                onChange={handleSearch2}
              />
              <div className="search-icon">
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                      stroke="#A79EB7"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
            </div>
            <div
              className="filter"
              onClick={() => {
                setShow(true);
              }}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.5833 1.25H3.41667C2.22005 1.25 1.25 2.22005 1.25 3.41667V4.68587C1.25 5.26051 1.47827 5.8116 1.88461 6.21794L8.19873 12.5321C8.60506 12.9384 8.83333 13.4895 8.83333 14.0641V19.6667V19.9762C8.83333 20.6615 9.66198 21.0047 10.1466 20.5201L11 19.6667L12.5321 18.1346C12.9384 17.7283 13.1667 17.1772 13.1667 16.6026V14.0641C13.1667 13.4895 13.3949 12.9384 13.8013 12.5321L20.1154 6.21794C20.5217 5.8116 20.75 5.26051 20.75 4.68587V3.41667C20.75 2.22005 19.78 1.25 18.5833 1.25Z"
                  stroke="#4E465E"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          <div
            className="btn-group mb-3"
            role="group"
            aria-label="Basic example"
          >
            <button type="button" className="btn btn-success">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 512 512"
                  fill="#000000"
                  stroke="#000000"
                >
                  <path d="m294 56 2.604.504C342.607 65.725 384.81 91.238 414 128l2.41 2.965C433.036 151.859 444.333 175.51 452 201l1.164 3.813c1.095 4.174 1.494 7.91.836 12.187-2.153 3.614-4.157 5.413-8 7-2.179.246-2.179.246-4.581.24l-2.77.009-3.017-.022h-3.194c-3.485 0-6.969-.016-10.454-.032l-7.247-.008c-6.359-.008-12.717-.028-19.076-.05-6.489-.02-12.977-.03-19.466-.04Q357.098 224.066 338 224l.846 2.492 1.102 3.272 1.096 3.242C344.5 243.83 345.552 256.874 343 268l2.719-1.172c26.449-11.148 53.602-12.705 81.969-9.515l3.18.356c20.745 2.573 20.745 2.573 26.132 8.331 6.845 13.69-3.093 39.88-7.437 53.387C435.633 361.13 408.953 397.584 373 423l-1.775 1.256c-22.198 15.459-55.06 33.562-82.948 32.178-4.213-.803-5.597-1.999-8.277-5.434-2.48-7.774-2.672-16.295-3.187-24.375l-.13-2.034c-1.788-28.848.67-56.725 8.317-84.591l-2.875.875C265.137 345.655 247 345.912 230 341a686 686 0 0 0-4-1l.503 1.898c5.948 22.745 8.75 44.507 8.81 67.977l.01 2.453c.022 9.035-.295 17.996-1.155 26.992l-.209 2.37c-.499 4.661-1.435 8.253-3.959 12.31-4.363 3.035-7.4 3.22-12.625 2.563-51.838-9.798-98.494-40.249-128.841-83.313C70.539 346.856 58.716 317.659 54 286l-.578-3.758c-.72-5.527-1.318-10.901.703-16.18 7.865-8.651 25.242-8.584 36.153-9.188 5.74-.239 11.478-.297 17.222-.312l2.383-.018c14.94-.075 29.816 1.327 43.93 6.519l2.228.775c3.693 1.295 7.33 2.699 10.959 4.162l.028-2.041c.257-14.768 1.288-27.906 5.972-41.959l-1.654.008q-19.944.1-39.888.147-9.645.022-19.29.071-9.308.048-18.615.059-3.551.008-7.103.032c-3.315.022-6.63.025-9.947.024l-2.966.032c-5.259-.024-9.02-.362-13.537-3.373-3.233-4.38-3.073-7.425-2.417-12.53.686-4.066 1.775-7.967 2.98-11.907.263-.867.527-1.733.8-2.625C64.195 184.946 67.863 176.46 72 168l1.14-2.355C91.094 128.962 119.834 99.508 155 79l1.785-1.057C197.226 54.238 248.175 46.998 294 56m-92 27-2.289.717C180.403 89.924 161.888 99.362 146 112l-1.596 1.259C115.814 135.982 94.873 165.449 83 200v2c13.187.326 26.373.574 39.563.725 6.126.073 12.25.172 18.374.331 5.92.153 11.838.236 17.76.272q3.375.039 6.748.152c13.237.75 13.237.75 24.902-4.514 3.033-2.86 5.597-5.994 8.162-9.271 10.754-12.221 31.471-19.045 47.202-20.566 26.387-1.486 50.168 5.378 70.316 23.027 1.626 1.462 2.963 2.83 4.22 4.625 1.99 2.815 3.552 4.87 6.94 5.854 2.674.226 5.267.231 7.95.16l3.046.003a657 657 0 0 0 9.934-.114q3.451-.02 6.902-.03c6.047-.027 12.093-.096 18.14-.173 6.173-.072 12.347-.104 18.52-.14A6078 6078 0 0 0 428 202c-5.192-33.127-33.105-67.2-59-87l-2.832-2.344C340.974 92.216 309.903 80.524 278 76l-2.723-.398C250.846 72.736 225.38 75.594 202 83m6.25 127.125c-13.002 13.564-18.869 30.856-18.527 49.508.8 17.854 9.052 33.633 21.879 45.844 13.447 11.587 29.876 17.48 47.613 16.902 19.444-1.947 35.496-10.258 48.133-25.145 4.578-5.99 7.974-12.194 10.652-19.234l.969-2.398c5.343-15.684 2.73-34.004-4.094-48.664-8.56-16.774-22.293-27.609-39.793-34.004-24.363-7.278-48.584.123-66.832 17.191M77 281c-1.558 36.118 24.224 74.8 47.417 100.307C138.628 396.504 155.61 408.417 174 418l1.83.957c17.4 9.13 17.4 9.13 36.17 13.043 5.166-39.138-.519-86.849-25.062-119-16.036-20.207-36.29-28.914-61.063-33.59-5.934-.628-11.85-.6-17.812-.598l-3.907-.001c-9.202.05-18.091.59-27.156 2.189m252.816 24.031c-14.73 15.055-22.606 36.153-27.003 56.344l-.47 2.138c-2.787 13.667-3.658 27.28-3.549 41.193.019 2.452.02 4.904.02 7.356l.018 4.758.003 2.182c.042 4.436.45 8.633 1.165 12.998 31.958-8.335 59.286-24.12 83-47l2.352-2.195c26.876-25.737 43.9-62.402 49.648-98.805v-3c-37.35-6.667-76.76-3.592-105.184 24.031"></path>
                  <path d="m255.625 3.688 2.941.006C272.891 3.745 286.926 4.08 301 7l3.011.618C338.707 14.956 372.086 28.237 401 49l1.947 1.377c9.753 6.933 18.656 14.492 27.224 22.84a860 860 0 0 0 5.493 5.29c7.345 7.108 13.915 14.527 20.014 22.726 1.32 1.765 2.67 3.505 4.025 5.244 29.473 38.314 48.23 89.368 48.5 137.843l.022 2.586C508.552 298.204 498.145 347.292 470 391l-1.295 2.012C437.519 440.882 391.365 477.832 337 496l-2.42.826C271.814 517.964 202.22 511.799 143 483c-22.896-11.436-43.566-26.265-62-44l-1.9-1.817C69.904 428.34 61.552 419.279 54 409l-2.473-3.281C19.554 362.723 2.797 310.332 2.75 256.875l-.002-2.101c.104-67.95 28.172-131.554 75.815-179.586A196 196 0 0 1 97 59l2.898-2.344C121.835 39.196 146.673 26.41 173 17l2.459-.886c9.565-3.39 19.224-5.84 29.166-7.864l2.958-.603c16.043-3.09 31.736-4.025 48.042-3.96M155 49l-2.181 1.073C134.959 58.883 118.837 69.726 104 83l-2.7 2.367C91.999 93.601 83.698 102.245 76 112l-2.402 2.957c-37.84 47.524-53.54 109.173-46.953 169.107C29.499 307.667 35.955 330.457 46 352l.988 2.123c10.708 22.716 24.673 43.224 42.31 61.144a489 489 0 0 1 4.98 5.163c7.36 7.636 15.217 14.248 23.722 20.57l1.69 1.284C156.214 470.016 203.26 485.834 249 487l3.273.121c56.994 1.15 114.602-20.405 156.477-59.058 1.978-1.814 4.002-3.533 6.063-5.25C425.12 413.796 434.049 403.11 442 392l1.385-1.918c35.153-49.185 49.858-111.3 40.154-171.038-8.168-46.129-28.946-88.885-61.884-122.358a416 416 0 0 1-4.71-4.893C409.86 84.418 402.188 78.111 394 72c-.543-.415-1.086-.83-1.646-1.256C325.328 19.639 230.149 11.136 155 49"></path>
                </svg>
              </span>
              Driver
            </button>
            <button
              type="button"
              className="btn btn-primary"
              style={{ backgroundColor: "#9ECAD6" }}
            >
              <span>
                <svg
                  version="1.1"
                  id="svg1038"
                  xmlSpace="preserve"
                  width="26"
                  height="26"
                  viewBox="0 0 682.66669 682.66669"
                  xmlns="http://www.w3.org/2000/svg"
                  // {...props}
                >
                  <g transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)">
                    <g transform="translate(226,165)">
                      <path
                        d="M 0,0 30,-30 60,0"
                        style={{
                          fill: "none",
                          stroke: "#000000",
                          strokeWidth: 25,
                          strokeLinecap: "butt",
                          strokeLinejoin: "miter",
                          strokeMiterlimit: 10,
                          strokeDasharray: "none",
                          strokeOpacity: 1,
                        }}
                      />
                    </g>
                    <g>
                      <g>
                        <g>
                          <g transform="translate(155.7979,164.1362)">
                            <path
                              d="M 0,0 122.021,-149.136"
                              style={{
                                fill: "none",
                                stroke: "#000000",
                                strokeWidth: 25,
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                strokeDasharray: "none",
                                strokeOpacity: 1,
                              }}
                            />
                          </g>
                          <g transform="translate(286,317)">
                            <path
                              d="m 0,0 h -60 c -33.137,0 -60,26.863 -60,60 H 60 C 60,26.863 33.137,0 0,0 Z"
                              style={{
                                fill: "none",
                                stroke: "#000000",
                                strokeWidth: 25,
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                strokeDasharray: "none",
                                strokeOpacity: 1,
                              }}
                            />
                          </g>
                          <g transform="translate(346,347)">
                            <path
                              d="M 0,0 C 16.568,0 30,-13.431 30,-30 30,-46.569 16.568,-60 0,-60 0,-99.3 -24.9,-134.6 -60,-146.9 V -182 H 0 c 33.137,0 60,-26.863 60,-60 v -90 h -300 v 90 c 0,33.137 26.863,60 60,60 h 60 v 35.1 c -35.1,12.3 -60,47.6 -60,86.9 -16.568,0 -30,13.431 -30,30 0,16.569 13.432,30 30,30"
                              style={{
                                fill: "none",
                                stroke: "#000000",
                                strokeWidth: 25,
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                strokeDasharray: "none",
                                strokeOpacity: 1,
                              }}
                            />
                          </g>
                          <g transform="translate(166,347)">
                            <path
                              d="m 0,0 v 30 c -36.434,13.683 -60,20.463 -60,45 0,41.421 67.157,75 150,75 82.843,0 150,-33.579 150,-75 0,-24.537 -23.566,-31.317 -60,-45 V 0"
                              style={{
                                fill: "none",
                                stroke: "#000000",
                                strokeWidth: 25,
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                strokeDasharray: "none",
                                strokeOpacity: 1,
                              }}
                            />
                          </g>
                          <g transform="translate(301,75)">
                            <path
                              d="M 0,0 H 60"
                              style={{
                                fill: "none",
                                stroke: "#000000",
                                strokeWidth: 25,
                                strokeLinecap: "butt",
                                strokeLinejoin: "miter",
                                strokeMiterlimit: 10,
                                strokeDasharray: "none",
                                strokeOpacity: 1,
                              }}
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              <span>Conductor</span>
            </button>
          </div>

          <div
            className="scroll_list"
            style={{
              height: height - 220,
              overflowY: "auto",
            }}
          >
            <div className="note2">
              <div
                className={
                  checked === "1"
                    ? "Present"
                    : checked === "0"
                    ? "Absent"
                    : "Allocated"
                }
              >
                <span>Regular</span>
              </div>
            </div>
            <hr />
            <div className="list-flex mb-4">
              <div className="list">
                <div className="scroll-list">
                  {Array.isArray(filter2 ? filteredDataDrv : drvList)
                    ? (filter2 ? filteredDataDrv : drvList)
                        .filter(
                          (item) =>
                            !spareCode.includes(item.allocationcode) &&
                            item.allocationcode !== "Reliver" &&
                            !item.allocationcode.includes("re-") &&
                            item.statuscode !== "3"
                        )
                        .map((item) => {
                          const data = draggedDrvDatas.filter(
                            (item2) => item2.driverNo === item.empcode
                          );
                          return (
                            <div
                              className={
                                data && data.length > 0
                                  ? "item disabled"
                                  : item.statuscode === "1"
                                  ? "item draggable"
                                  : "item"
                              }
                              key={item.empcode}
                              draggable
                              onDragStart={(event) =>
                                onDragStartDrv(
                                  event,
                                  item.empcode,
                                  item.statuscode,
                                  "drv"
                                )
                              }
                              onDragOver={(event) => onDragOver(event)}
                              title={
                                item.statuscode === "1"
                                  ? "Available"
                                  : item.statuscode === "0"
                                  ? "Not Available"
                                  : item.statuscode === "2"
                                  ? "Allocated"
                                  : "Double Duty"
                              }
                            >
                              <div className="icon">
                                <span>
                                  {item.photo !== "" ? (
                                    <>
                                      <img
                                        src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                        width={40}
                                        alt=""
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <div className="input-file">
                                        <img src={Crew} width={40} alt="" />
                                        <input
                                          type="file"
                                          name="profile"
                                          onChange={(e) => {
                                            handleFileChange(e, item.traycode);
                                          }}
                                        />
                                      </div>
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="info">
                                <span className="name">{item.empname}</span>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <span className="code">
                                    {item.empcode}{" "}
                                    {item.statuscode !== "2" && (
                                      <>| {item.allocationcode}</>
                                    )}{" "}
                                  </span>
                                  {item.statuscode === "2" && (
                                    <>
                                      <span
                                        className="Present assign"
                                        onClick={(e) => {
                                          setShow7(true);
                                          setDutyData(item);
                                          setEmpType("1");
                                        }}
                                      >
                                        Assign
                                      </span>
                                    </>
                                  )}

                                  {item.statuscode === "1" ? (
                                    <>
                                      <button
                                        className="circle present"
                                        title="Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "0" ? (
                                    <>
                                      <button
                                        className="circle absent"
                                        title="Not Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "2" ? (
                                    <>
                                      <span> {item.allocationcode}</span>
                                      <button
                                        className="circle"
                                        title="Allocated"
                                      >
                                        <RiCheckDoubleFill
                                          color="green"
                                          style={{
                                            height: "23px",
                                            width: "23px",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : null}
                                </div>
                                <div className="">
                                  {/^\d+\/\d+$/.test(item.allocationcode) ? (
                                    <>
                                      <strong
                                        className="text-primary"
                                        title="Duty Time"
                                      >
                                        {item.dutyTime}
                                      </strong>{" "}
                                      {item.statuscode !== "0" ? " | " : ""}
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  ) : (
                                    <>
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                    : null}
                </div>
              </div>
              <div className="list">
                <div className="scroll-list">
                  {Array.isArray(filter2 ? filteredDataCond : condList)
                    ? (filter2 ? filteredDataCond : condList)
                        .filter(
                          (item) =>
                            !spareCode.includes(item.allocationcode) &&
                            item.allocationcode !== "Reliver" &&
                            !item.allocationcode.includes("re-") &&
                            item.statuscode !== "3"
                        )
                        .map((item, index) => {
                          const data = draggedCondDatas.filter(
                            (item2) => item2.condNo === item.empcode
                          );
                          return (
                            <div
                              className={
                                data && data.length > 0
                                  ? "item disabled"
                                  : item.statuscode === "1"
                                  ? "item draggable"
                                  : "item"
                              }
                              key={item.empcode}
                              draggable
                              onDragStart={(event) =>
                                onDragStartCon(
                                  event,
                                  item.empcode,
                                  item.statuscode,
                                  "cond"
                                )
                              }
                              onDragOver={(event) => onDragOver(event)}
                              title={
                                item.statuscode === "1"
                                  ? "Available"
                                  : item.statuscode === "0"
                                  ? "Not Available"
                                  : item.statuscode === "2"
                                  ? "Allocated"
                                  : "Double Duty"
                              }
                            >
                              <div className="icon">
                                <span>
                                  {item.photo !== "" ? (
                                    <>
                                      <img
                                        src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                        width={40}
                                        alt=""
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <img src={Crew} width={40} alt="" />
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="info">
                                <span className="name">{item.empname}</span>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <span className="code">
                                    {item.empcode}{" "}
                                    {item.statuscode !== "2" && (
                                      <>| {item.allocationcode}</>
                                    )}
                                  </span>
                                  {/* <span>{item.allocationcode}</span> */}
                                  {item.statuscode === "2" && (
                                    <>
                                      <span
                                        className="Present assign"
                                        onClick={(e) => {
                                          setShow7(true);
                                          setDutyData(item);
                                          setEmpType("2");
                                        }}
                                      >
                                        Assign
                                      </span>
                                    </>
                                  )}
                                  {item.statuscode === "1" ? (
                                    <>
                                      <button
                                        className="circle present"
                                        title="Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "0" ? (
                                    <>
                                      <button
                                        className="circle absent"
                                        title="Not Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "2" ? (
                                    <>
                                      <span> {item.allocationcode}</span>
                                      <button
                                        className="circle"
                                        title="Allocated"
                                      >
                                        <RiCheckDoubleFill
                                          color="green"
                                          style={{
                                            height: "23px",
                                            width: "23px",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : null}
                                </div>
                                <div className="">
                                  {/^\d+\/\d+$/.test(item.allocationcode) ? (
                                    <>
                                      <strong
                                        className="text-primary"
                                        title="Duty Time"
                                      >
                                        {item.dutyTime}
                                      </strong>
                                      {item.statuscode !== "0" ? " | " : ""}
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  ) : (
                                    <>
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                    : null}
                </div>
              </div>
            </div>

            <div className="note2">
              <div
                className={
                  checked === "1"
                    ? "Present"
                    : checked === "0"
                    ? "Absent"
                    : "Allocated"
                }
              >
                <span>Reliver</span>
              </div>
            </div>
            <hr />
            <div className="list-flex mb-4">
              <div className="list">
                <div className="scroll-list">
                  {Array.isArray(filter2 ? filteredDataDrv : drvList)
                    ? (filter2 ? filteredDataDrv : drvList)
                        .filter(
                          (item) =>
                            (item.allocationcode === "Reliver" ||
                              item.allocationcode.includes("re-")) &&
                            item.statuscode !== "3"
                        )
                        .map((item) => {
                          const data = draggedDrvDatas.filter(
                            (item2) => item2.driverNo === item.empcode
                          );
                          return (
                            <div
                              className={
                                data && data.length > 0
                                  ? "item disabled"
                                  : item.statuscode === "1"
                                  ? "item draggable"
                                  : "item"
                              }
                              key={item.empcode}
                              draggable
                              onDragStart={(event) =>
                                onDragStartDrv(
                                  event,
                                  item.empcode,
                                  item.statuscode,
                                  "drv"
                                )
                              }
                              onDragOver={(event) => onDragOver(event)}
                              title={
                                item.statuscode === "1"
                                  ? "Available"
                                  : item.statuscode === "0"
                                  ? "Not Available"
                                  : item.statuscode === "2"
                                  ? "Allocated"
                                  : "Double Duty"
                              }
                            >
                              <div className="icon">
                                <span>
                                  {item.photo !== "" ? (
                                    <>
                                      <img
                                        src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                        width={40}
                                        alt=""
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <img src={Crew} width={40} alt="" />
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="info">
                                <span className="name">{item.empname}</span>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <span className="code">{item.empcode}</span>
                                  {item.statuscode === "2" && (
                                    <>
                                      <span
                                        className="Present assign"
                                        onClick={(e) => {
                                          setShow7(true);
                                          setDutyData(item);
                                          setEmpType("1");
                                        }}
                                      >
                                        Assign
                                      </span>
                                    </>
                                  )}
                                  {item.statuscode === "1" ? (
                                    <>
                                      <button
                                        className="circle present"
                                        title="Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "0" ? (
                                    <>
                                      <button
                                        className="circle absent"
                                        title="Not Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "2" ? (
                                    <>
                                      <button
                                        className="circle"
                                        title="Allocated"
                                      >
                                        <RiCheckDoubleFill
                                          color="green"
                                          style={{
                                            height: "23px",
                                            width: "23px",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : null}
                                </div>
                                <div className="">
                                  {/^\d+\/\d+$/.test(item.allocationcode) ? (
                                    <>
                                      <strong
                                        className="text-primary"
                                        title="Duty Time"
                                      >
                                        {item.dutyTime}
                                      </strong>
                                      {item.statuscode !== "0" ? " | " : ""}
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  ) : (
                                    <>
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                    : null}
                </div>
              </div>
              <div className="list">
                <div className="scroll-list">
                  {Array.isArray(filter2 ? filteredDataCond : condList)
                    ? (filter2 ? filteredDataCond : condList)
                        .filter(
                          (item) =>
                            (item.allocationcode === "Reliver" ||
                              item.allocationcode.includes("re-")) &&
                            item.statuscode !== "3"
                        )
                        .map((item, index) => {
                          const data = draggedCondDatas.filter(
                            (item2) => item2.condNo === item.empcode
                          );
                          return (
                            <div
                              className={
                                data && data.length > 0
                                  ? "item disabled"
                                  : item.statuscode === "1"
                                  ? "item draggable"
                                  : "item"
                              }
                              key={item.empcode}
                              draggable
                              onDragStart={(event) =>
                                onDragStartCon(
                                  event,
                                  item.empcode,
                                  item.statuscode,
                                  "cond"
                                )
                              }
                              onDragOver={(event) => onDragOver(event)}
                              title={
                                item.statuscode === "1"
                                  ? "Available"
                                  : item.statuscode === "0"
                                  ? "Not Available"
                                  : item.statuscode === "2"
                                  ? "Allocated"
                                  : "Double Duty"
                              }
                            >
                              <div className="icon">
                                <span>
                                  {item.photo !== "" ? (
                                    <>
                                      <img
                                        src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                        width={40}
                                        alt=""
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <img src={Crew} width={40} alt="" />
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="info">
                                <span className="name">{item.empname}</span>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <span className="code">{item.empcode}</span>
                                  {item.statuscode === "2" && (
                                    <>
                                      <span
                                        className="Present assign"
                                        onClick={(e) => {
                                          setShow7(true);
                                          setDutyData(item);
                                          setEmpType("2");
                                        }}
                                      >
                                        Assign
                                      </span>
                                    </>
                                  )}
                                  {item.statuscode === "1" ? (
                                    <>
                                      <button
                                        className="circle present"
                                        title="Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "0" ? (
                                    <>
                                      <button
                                        className="circle absent"
                                        title="Not Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "2" ? (
                                    <>
                                      <button
                                        className="circle"
                                        title="Allocated"
                                      >
                                        <RiCheckDoubleFill
                                          color="green"
                                          style={{
                                            height: "23px",
                                            width: "23px",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : null}
                                </div>
                                <div className="">
                                  {/^\d+\/\d+$/.test(item.allocationcode) ? (
                                    <>
                                      <strong
                                        className="text-primary"
                                        title="Duty Time"
                                      >
                                        {item.dutyTime}
                                      </strong>
                                      {item.statuscode !== "0" ? " | " : ""}
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  ) : (
                                    <>
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                    : null}
                </div>
              </div>
            </div>

            <div className="note2">
              <div
                className={
                  checked === "1"
                    ? "Present"
                    : checked === "0"
                    ? "Absent"
                    : "Allocated"
                }
              >
                <span>Spare</span>
              </div>
            </div>
            <hr />
            <div className="list-flex mb-4">
              <div className="list">
                <div className="scroll-list">
                  {Array.isArray(filter2 ? filteredDataDrv : drvList)
                    ? (filter2 ? filteredDataDrv : drvList)
                        .filter(
                          (item) =>
                            spareCode.includes(item.allocationcode) &&
                            item.statuscode !== "3"
                        )
                        .map((item) => {
                          const data = draggedDrvDatas.filter(
                            (item2) => item2.driverNo === item.empcode
                          );

                          return (
                            <div
                              className={
                                data && data.length > 0
                                  ? "item disabled"
                                  : item.statuscode === "1"
                                  ? "item draggable"
                                  : "item"
                              }
                              key={item.empcode}
                              draggable
                              onDragStart={(event) =>
                                onDragStartDrv(
                                  event,
                                  item.empcode,
                                  item.statuscode,
                                  "drv"
                                )
                              }
                              onDragOver={(event) => onDragOver(event)}
                              title={
                                item.statuscode === "1"
                                  ? "Available"
                                  : item.statuscode === "0"
                                  ? "Not Available"
                                  : item.statuscode === "2"
                                  ? "Allocated"
                                  : "Double Duty"
                              }
                            >
                              <div className="icon">
                                <span>
                                  {item.photo !== "" ? (
                                    <>
                                      <img
                                        src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                        width={40}
                                        alt=""
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <img src={Crew} width={40} alt="" />
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="info">
                                <span className="name">{item.empname}</span>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <span className="code">{item.empcode}</span>
                                  {item.statuscode === "2" && (
                                    <>
                                      <span
                                        className="Present assign"
                                        onClick={(e) => {
                                          setShow7(true);
                                          setDutyData(item);
                                          setEmpType("1");
                                        }}
                                      >
                                        Assign
                                      </span>
                                    </>
                                  )}
                                  {item.statuscode === "1" ? (
                                    <>
                                      <button
                                        className="circle present"
                                        title="Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "0" ? (
                                    <>
                                      <button
                                        className="circle absent"
                                        title="Not Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "2" ? (
                                    <>
                                      <button
                                        className="circle"
                                        title="Allocated"
                                      >
                                        <RiCheckDoubleFill
                                          color="green"
                                          style={{
                                            height: "23px",
                                            width: "23px",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : null}
                                </div>
                                <div className="">
                                  {/^\d+\/\d+$/.test(item.allocationcode) ? (
                                    <>
                                      <strong
                                        className="text-primary"
                                        title="Duty Time"
                                      >
                                        {item.dutyTime}
                                      </strong>
                                      {item.statuscode !== "0" ? " | " : ""}
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  ) : (
                                    <>
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                    : null}
                </div>
              </div>
              <div className="list">
                <div className="scroll-list">
                  {Array.isArray(filter2 ? filteredDataCond : condList)
                    ? (filter2 ? filteredDataCond : condList)
                        .filter(
                          (item) =>
                            spareCode.includes(item.allocationcode) &&
                            item.statuscode !== "3"
                        )
                        .map((item, index) => {
                          const data = draggedCondDatas.filter(
                            (item2) => item2.condNo === item.empcode
                          );

                          return (
                            <div
                              className={
                                data && data.length > 0
                                  ? "item disabled"
                                  : item.statuscode === "1"
                                  ? "item draggable"
                                  : "item"
                              }
                              key={item.empcode}
                              draggable
                              onDragStart={(event) =>
                                onDragStartCon(
                                  event,
                                  item.empcode,
                                  item.statuscode,
                                  "cond"
                                )
                              }
                              onDragOver={(event) => onDragOver(event)}
                              title={
                                item.statuscode === "1"
                                  ? "Available"
                                  : item.statuscode === "0"
                                  ? "Not Available"
                                  : item.statuscode === "2"
                                  ? "Allocated"
                                  : "Double Duty"
                              }
                            >
                              <div className="icon">
                                <span>
                                  {item.photo !== "" ? (
                                    <>
                                      <img
                                        src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                        width={40}
                                        alt=""
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <img src={Crew} width={40} alt="" />
                                    </>
                                  )}
                                </span>
                              </div>
                              <div className="info">
                                <span className="name">{item.empname}</span>
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                  <span className="code">{item.empcode}</span>
                                  {item.statuscode === "2" && (
                                    <>
                                      <span
                                        className="Present assign"
                                        onClick={(e) => {
                                          setShow7(true);
                                          setDutyData(item);
                                          setEmpType("2");
                                        }}
                                      >
                                        Assign
                                      </span>
                                    </>
                                  )}
                                  {item.statuscode === "1" ? (
                                    <>
                                      <button
                                        className="circle present"
                                        title="Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "0" ? (
                                    <>
                                      <button
                                        className="circle absent"
                                        title="Not Available"
                                      ></button>
                                    </>
                                  ) : item.statuscode === "2" ? (
                                    <>
                                      <button
                                        className="circle"
                                        title="Allocated"
                                      >
                                        <RiCheckDoubleFill
                                          color="green"
                                          style={{
                                            height: "23px",
                                            width: "23px",
                                          }}
                                        />
                                      </button>
                                    </>
                                  ) : null}
                                </div>
                                <div className="">
                                  {/^\d+\/\d+$/.test(item.allocationcode) ? (
                                    <>
                                      <strong
                                        className="text-primary"
                                        title="Duty Time"
                                      >
                                        {item.dutyTime}
                                      </strong>
                                      {item.statuscode !== "0" ? " | " : ""}
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  ) : (
                                    <>
                                      <strong
                                        className="text-success"
                                        title="Arrival Time"
                                      >
                                        {item.arrivalTime}
                                      </strong>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        })
                    : null}
                </div>
              </div>
            </div>

            {checked === "1" && (
              <>
                <div className="note2">
                  <div
                    className={
                      checked === "1"
                        ? "Present"
                        : checked === "0"
                        ? "Absent"
                        : "Allocated"
                    }
                  >
                    <span>Double Duty</span>
                  </div>
                </div>
                <hr />
                <div className="list-flex">
                  <div className="list">
                    <div className="scroll-list">
                      {Array.isArray(filter2 ? filteredDataDrv : drvList)
                        ? (filter2 ? filteredDataDrv : drvList)
                            .filter((item) => item.statuscode === "3")
                            .map((item) => {
                              const data = draggedDrvDatas.filter(
                                (item2) => item2.driverNo === item.empcode
                              );

                              return (
                                <div
                                  className={
                                    data && data.length > 0
                                      ? "item disabled"
                                      : "item"
                                  }
                                  key={item.empcode}
                                  draggable
                                  onDragStart={(event) =>
                                    onDragStartDrv(
                                      event,
                                      item.empcode,
                                      item.statuscode,
                                      "drv"
                                    )
                                  }
                                  onDragOver={(event) => onDragOver(event)}
                                  title={
                                    item.statuscode === "1"
                                      ? "Available"
                                      : item.statuscode === "0"
                                      ? "Not Available"
                                      : item.statuscode === "2"
                                      ? "Allocated"
                                      : "Double Duty"
                                  }
                                >
                                  <div className="icon">
                                    <span>
                                      {item.photo !== "" ? (
                                        <>
                                          <img
                                            src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                            width={40}
                                            alt=""
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <img src={Crew} width={40} alt="" />
                                        </>
                                      )}
                                    </span>
                                  </div>
                                  <div className="info">
                                    <span className="name">{item.empname}</span>
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                      <span className="code">
                                        {item.empcode}
                                      </span>
                                      {item.statuscode === "2" && (
                                        <>
                                          <span className="Present assign">
                                            Assign
                                          </span>
                                        </>
                                      )}
                                      {item.statuscode === "1" ||
                                      item.statuscode === "3" ? (
                                        <>
                                          <button
                                            className="circle present"
                                            title="Available"
                                          ></button>
                                        </>
                                      ) : item.statuscode === "0" ? (
                                        <>
                                          <button
                                            className="circle absent"
                                            title="Not Available"
                                          ></button>
                                        </>
                                      ) : item.statuscode === "2" ? (
                                        <>
                                          <button
                                            className="circle"
                                            title="Allocated"
                                          >
                                            <RiCheckDoubleFill
                                              color="green"
                                              style={{
                                                height: "23px",
                                                width: "23px",
                                              }}
                                            />
                                          </button>
                                        </>
                                      ) : null}
                                    </div>
                                    <div className="">
                                      {/^\d+\/\d+$/.test(
                                        item.allocationcode
                                      ) ? (
                                        <>
                                          <strong
                                            className="text-primary"
                                            title="Duty Time"
                                          >
                                            {item.dutyTime}
                                          </strong>
                                          {item.statuscode !== "0" ? " | " : ""}
                                          <strong
                                            className="text-success"
                                            title="Arrival Time"
                                          >
                                            {item.arrivalTime}
                                          </strong>
                                        </>
                                      ) : (
                                        <>
                                          <strong
                                            className="text-success"
                                            title="Arrival Time"
                                          >
                                            {item.arrivalTime}
                                          </strong>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        : null}
                    </div>
                  </div>
                  <div className="list">
                    <div className="scroll-list">
                      {Array.isArray(filter2 ? filteredDataCond : condList)
                        ? (filter2 ? filteredDataCond : condList)
                            .filter((item) => item.statuscode === "3")
                            .map((item, index) => {
                              const data = draggedCondDatas.filter(
                                (item2) => item2.condNo === item.empcode
                              );
                              return (
                                <div
                                  className={
                                    data && data.length > 0
                                      ? "item disabled"
                                      : "item"
                                  }
                                  key={item.empcode}
                                  draggable
                                  onDragStart={(event) =>
                                    onDragStartCon(
                                      event,
                                      item.empcode,
                                      item.statuscode,
                                      "cond"
                                    )
                                  }
                                  onDragOver={(event) => onDragOver(event)}
                                  title={
                                    item.statuscode === "1"
                                      ? "Available"
                                      : item.statuscode === "0"
                                      ? "Not Available"
                                      : item.statuscode === "2"
                                      ? "Allocated"
                                      : "Double Duty"
                                  }
                                >
                                  <div className="icon">
                                    <span>
                                      {item.photo !== "" ? (
                                        <>
                                          <img
                                            src={`${TEST_BK_URL}/crewPhoto/${item.traycode}/${item.photo}`}
                                            width={40}
                                            alt=""
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <img src={Crew} width={40} alt="" />
                                        </>
                                      )}
                                    </span>
                                  </div>
                                  <div className="info">
                                    <span className="name">{item.empname}</span>
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                      <span className="code">
                                        {item.empcode}
                                      </span>
                                      {item.statuscode === "2" && (
                                        <>
                                          <span className="Present assign">
                                            Assign
                                          </span>
                                        </>
                                      )}
                                      {item.statuscode === "1" ||
                                      item.statuscode === "3" ? (
                                        <>
                                          <button
                                            className="circle present"
                                            title="Available"
                                          ></button>
                                        </>
                                      ) : item.statuscode === "0" ? (
                                        <>
                                          <button
                                            className="circle absent"
                                            title="Not Available"
                                          ></button>
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            className="circle"
                                            title="Allocated"
                                          >
                                            <RiCheckDoubleFill
                                              color="green"
                                              style={{
                                                height: "23px",
                                                width: "23px",
                                              }}
                                            />
                                          </button>
                                        </>
                                      )}
                                    </div>
                                    <div className="">
                                      {/^\d+\/\d+$/.test(
                                        item.allocationcode
                                      ) ? (
                                        <>
                                          <strong
                                            className="text-primary"
                                            title="Duty Time"
                                          >
                                            {item.dutyTime}
                                          </strong>
                                          {item.statuscode !== "0" ? " | " : ""}
                                          <strong
                                            className="text-success"
                                            title="Arrival Time"
                                          >
                                            {item.arrivalTime}
                                          </strong>
                                        </>
                                      ) : (
                                        <>
                                          <strong
                                            className="text-success"
                                            title="Arrival Time"
                                          >
                                            {item.arrivalTime}
                                          </strong>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                        : null}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div
        className={`${show ? "modal-overlay" : ""}`}
        onClick={(e) => {
          setShow(false);
        }}
      >
        <div className="" onClick={(e) => e.stopPropagation()}>
          <div className={show ? "filterModal active" : "filterModal"}>
            <div className="filter-flex">
              <div className="sort-list">
                <div className="heading mb-3">
                  <span>Filters</span>
                </div>
                <div className="csort">
                  <div className="statusFilter-flex visible">
                    <div className="sort-flex">
                      <span className="status-filter lateMark">Allocated</span>
                      <label className="checkbox-container">
                        <input
                          type="radio"
                          value="2"
                          checked={checked === "2"}
                          onChange={handleChecked}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                    <div className="sort-flex">
                      <span className="status-filter absent">Unavailable</span>
                      <label className="checkbox-container">
                        <input
                          type="radio"
                          value="0"
                          checked={checked === "0"}
                          onChange={handleChecked}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>

                    <div className="sort-flex">
                      <span className="status-filter present">Available</span>
                      <label className="checkbox-container">
                        <input
                          type="radio"
                          value="1"
                          checked={checked === "1"}
                          onChange={handleChecked}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Duty</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update bus no. to this duty!
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow2(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={updateDuty}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show3}
        onHide={() => {
          setShow3(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Conductor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update Conductor to this duty!
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow3(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={updateDutyCon}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show4}
        onHide={() => {
          setShow4(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update driver to this duty!
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow4(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={updateDutyDrv}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show6}
        onHide={() => {
          setShow6(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Duty</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to cancel the duty!</p>
          <p>Reason:</p>
          <div className="busno">
            <select
              name="selectedReason"
              id="selectedReason"
              value={selectedReason}
              onChange={(e) => handleSelectChange(e)}
            >
              <option value="14">Computer</option>
              <option value="1/1">Driver</option>
              <option value="1/2">Conductor</option>
              <option value="2">Bus</option>
              <option value="8">Scheduled Suspend</option>
              <option selected value="9">
                No Delay
              </option>
            </select>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow6(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={cancelDuty}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show7}
        onHide={() => {
          setShow7(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Double Duty</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to assign the duty!</p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow7(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={assignDoubleDuty}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default DutyList;
